import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import '@babel/runtime/helpers/typeof';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { parse } from 'himalaya';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

var fillMissing = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, useid, occid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          useid = d.UseId;
          occid = d.OccasionId;
          try {
            d.DieTypeId = getDieTypeId({
              useid: useid,
              occid: occid
            });

            // let oin = d.OrderedItemNumber;
            // let dt = d.Parent.OrderDate;

            // let cc =  getCommodityCode({oin, dt});
            // d.CommodityCode = cc;
          } catch (error) {
            console.log(error);
            d.errors.push({
              message: "Cannot find OccasionUseXRef record for OccasionId ".concat(occid, " UseId ").concat(useid),
              errorDetails: error,
              error: true
            });
          }
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fillMissing(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getDieTypeId = function getDieTypeId(_ref3) {
  var useid = _ref3.useid,
    occid = _ref3.occid;
  // console.log("in get die type",useid,occid);

  var OccasionUseXRef = pricer["OccasionUseXRef"];
  var jsonContent = OccasionUseXRef;
  var xr = jsonContent.filter(function (x) {
    return x[pricerFieldsIdx["OccasionUseXRef"]["OccasionID"]].toLowerCase() == occid.toLowerCase() && x[pricerFieldsIdx["OccasionUseXRef"]["UseID"]].toLowerCase() == useid.toLowerCase();
  })[0];
  if (!xr) {
    // xr = window.pricerRecordsDefault.OccasionUseXRef;
    //  throw { error: `Cannot find OccasionUseXRef record for OccasionId ${occid} UseId ${useid}` }
    return 0;
  }
  var dt = xr[pricerFieldsIdx["OccasionUseXRef"]["DieTypeID"]];
  return dt ? dt : 0;
};

var Process = {
  NONE: 0,
  /// <summary>
  /// Thermo
  /// </summary>
  T: 1,
  /// <summary>
  /// Engraved
  /// </summary>
  E: 2,
  /// <summary>
  /// Letterpress
  /// </summary>
  L: 5,
  /// <summary>
  /// Blind Embossed
  /// </summary>
  B: 6,
  /// <summary>
  /// Flat Print/Litho
  /// </summary>
  F: 7,
  /// <summary>
  /// Shell
  /// </summary>
  SHELL: 13,
  /// <summary>
  /// Plain
  /// </summary>
  P: "14",
  /// <summary>
  /// Roll Leaf/Foil
  /// </summary>
  R: 15,
  /// <summary>
  /// Silk Screen
  /// </summary>
  S: 16,
  /// <summary>
  /// 4-Color Process
  /// </summary>
  FOUR: 17,
  UNKNOWN: 18,
  /// <summary>
  /// CM Digital
  /// </summary>
  D: 19,
  /// <summary>
  /// CM Digital Wite
  /// </summary>
  X: 20,
  /// <summary>
  /// Digital
  /// </summary>
  G: 21
};
var Surface = {
  NONE: 0,
  FRONT: 1,
  BACK: 2,
  FACE: 3,
  FLAP: 4,
  INSIDE: 5,
  OUTSIDE: 6,
  BOTTOMBACK: 7
};
var SublineType = {
  NOTASUBLINE: 0,
  OMSAPR: 1,
  RIBBON: 3,
  OMSSEL: 4,
  ADHOC: 6,
  UNKNOWN: 7,
  LINER: 8,
  MOTIF: 9,
  MONOGRAM: 10,
  TEXT: 11,
  FRAME: 12,
  TEXTMOTIF: 13,
  SUPPLIED: 14,
  ITEM: 15,
  OMSOCA: 17,
  PDSSC: 18,
  OMSREG: 19,
  STOCK: 20,
  LEGPROMO: 21,
  OMSEXC: 22,
  BLEEDMOTIF: 23,
  PATTERN: 24,
  LINERTEXT: 25,
  LINERMONO: 27,
  LINERPTRN: 28,
  BDR: 29,
  DDC: 30,
  KALOGRAM: 31,
  PNTEDGE: 32,
  ASADHOC: 33,
  OMSWAAPR: 34,
  RUSH: 36,
  ASRUSH: 37,
  FOILEDGE: 38
};

/// <summary>
/// Corresponds to oms.SurchargeTypeMaster data
/// </summary>
var SurchargeCalculationType = {
  NOTFOUND: 0,
  FLAT: 1,
  QTY: 2,
  UNKNOWN: 3,
  WAAS: 4
};
var ChargeType = {
  Unknown: 0,
  Stock: 1,
  PrimaryPressRate: 2,
  Die: 3,
  TextUpgrade: 4,
  APRSurchargeNoDie: 5,
  APRSurchargeWithDie: 6,
  OCASurchargeNoDie: 7,
  OCASurchargeWithDie: 8,
  NonAmendedSubline: 9,
  RegularSurcharge: 10,
  CalculatedAPRSurchargeNoDie: 11,
  CalculatedAPRSurchargeWithDie: 12
};

var determinePrimaryProcess = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, ppp;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          // console.log("Enter PrimaryProcessColorAnalyzer.Evaluate for Detail " + d.RefId.toString());
          d.Parent.OrderDate;
          if (!(d.Sublines.length <= 0)) {
            _context.next = 6;
            break;
          }
          _context.next = 5;
          return makeEmptyPrimaryProcess({
            d: d
          });
        case 5:
          return _context.abrupt("return");
        case 6:
          _context.next = 8;
          return getUniqueProcessColorSurfaceSublineTypes({
            d: d
          });
        case 8:
          if (!(d.ProcessColorSurfaces == null || d.ProcessColorSurfaces.length <= 0)) {
            _context.next = 12;
            break;
          }
          _context.next = 11;
          return makeEmptyPrimaryProcess({
            d: d
          });
        case 11:
          return _context.abrupt("return");
        case 12:
          _context.next = 14;
          return analyzeTextForPrimaryProcessDefault({
            d: d
          });
        case 14:
          _context.next = 16;
          return textAsPrimaryProcessCheck({
            d: d
          });
        case 16:
          if (!_context.sent) {
            _context.next = 18;
            break;
          }
          return _context.abrupt("return");
        case 18:
          _context.next = 20;
          return findPrimaryProcessColorByHierarchy({
            d: d
          });
        case 20:
          ppp = _context.sent;
          d.PrimaryProcessColorSurface = ppp;
          "Line " + ppp.RefId + " Process " + ppp.Process.toString() + " Color " + ppp.ColorId.toString() + " Surface " + ppp.Surface.toString(); // console.log("PrimaryProcess is " + msg)
          //Now we have to clear and reload, without taking into
          //need to add
          //await getUniqueProcessColorSurfacesWithoutSublineTypes({d});
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function determinePrimaryProcess(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var makeEmptyPrimaryProcess = function makeEmptyPrimaryProcess(_ref3) {
  var d = _ref3.d;
  // let dto = new ProcessColorSurfaceDto();
  var dto = {};
  dto.Process = Process.P;
  // dto.Surface = Surface.NONE; old value
  dto.Surface = Surface.NONE;
  dto.ColorId = 0;
  d.PrimaryProcessColorSurface = dto;
  return;
};
var getUniqueProcessColorSurfaceSublineTypes = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
    var d, i, s, dto;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          d = _ref4.d;
          if (!(d.Sublines.length <= 0)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          i = 0;
        case 4:
          if (!(i < d.Sublines.length)) {
            _context2.next = 27;
            break;
          }
          s = d.Sublines[i]; // // console.log("Process",Process)
          if (s.Process) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("continue", 24);
        case 8:
          if (!(s.Process == Process.NONE)) {
            _context2.next = 10;
            break;
          }
          return _context2.abrupt("continue", 24);
        case 10:
          if (!(s.ColorId == 0)) {
            _context2.next = 12;
            break;
          }
          return _context2.abrupt("continue", 24);
        case 12:
          // console.log("i", i)
          // let pcsdto = new ProcessColorSurfaceDto();
          dto = {};
          dto.RefId = d.RefId;
          dto.DetailId = d.OrderDetailId;
          dto.Process = s.Process;
          dto.ColorId = s.ColorId;
          dto.SublineType = s.SublineType;
          dto.Surface = s.Surface;
          dto.OrderedQuantity = s.Quantity;
          dto.SublineIndex = s.SublineIndex;
          dto.SublineObjectId = s.SublineObjectId;
          _context2.next = 24;
          return applyAddRules({
            d: d,
            dto: dto
          });
        case 24:
          i++;
          _context2.next = 4;
          break;
        case 27:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getUniqueProcessColorSurfaceSublineTypes(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
var applyAddRules = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
    var d, dto, inLst, pcsdto;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          d = _ref6.d, dto = _ref6.dto;
          if (d.ProcessColorSurfaces == null) {
            d.ProcessColorSurfaces = [];
            // console.log("Detail{0}.ProcessColorSurfaces is null. Instantiating.", d.RefId);
          }
          _context3.next = 4;
          return indexOfProcessColorSurfaceDtoInList({
            d: d,
            dto: dto
          });
        case 4:
          inLst = _context3.sent;
          if (!(inLst < 0)) {
            _context3.next = 9;
            break;
          }
          dto.InstanceQuantity = 1;
          d.ProcessColorSurfaces.push(dto);
          return _context3.abrupt("return");
        case 9:
          pcsdto = d.ProcessColorSurfaces[inLst];
          pcsdto.InstanceQuantity++;
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function applyAddRules(_x3) {
    return _ref7.apply(this, arguments);
  };
}();
var indexOfProcessColorSurfaceDtoInList = function indexOfProcessColorSurfaceDtoInList(_ref8) {
  var d = _ref8.d,
    dto = _ref8.dto;
  var idx = -1;
  for (var i = 0; i < d.ProcessColorSurfaces.length; i++) {
    var pcs = d.ProcessColorSurfaces[i];
    if (checkPCSEqual(pcs, dto) && pcs.SublineType == dto.SublineType) {
      idx++;
      return idx;
    }
  }
  return idx;
};
var textAsPrimaryProcessCheck = function textAsPrimaryProcessCheck(_ref9) {
  var d = _ref9.d;
  for (var i = 0; i < d.Sublines.length; i++) {
    var s = d.Sublines[i];
    if (s.UseAsPrimaryProcess) {
      if (s.SublineType == SublineType.TEXT) {
        // let pcsdto = new ProcessColorSurfaceDto();
        var pcsdto = {};
        pcsdto.RefId = d.RefId;
        pcsdto.DetailId = d.OrderDetailId;
        pcsdto.Process = s.Process;
        pcsdto.ColorId = s.ColorId;
        pcsdto.SublineType = s.SublineType;
        pcsdto.Surface = s.Surface;
        pcsdto.OrderedQuantity = s.Quantity;
        pcsdto.SublineIndex = s.SublineIndex;
        pcsdto.SublineObjectId = s.SublineObjectId;
        d.PrimaryProcessColorSurface = pcsdto;
        "Text Primary Process Override: Line " + pcsdto.RefId + " Process " + pcsdto.Process.toString() + " Color " + pcsdto.ColorId.toString() + " Surface " + pcsdto.Surface.toString();

        // console.log("PrimaryProcess is " + msg)

        return true;
      }
    }
  }
  return false;
};
var findPrimaryProcessColorByHierarchy = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref10) {
    var d, orderDate, retDto, m, x, nextDto;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          d = _ref10.d;
          if (!(d == null)) {
            _context4.next = 3;
            break;
          }
          throw {
            error: "IList<ProcessColorSurfaceDto> cannot be null."
          };
        case 3:
          if (!(d.ProcessColorSurfaces.length <= 0)) {
            _context4.next = 5;
            break;
          }
          throw {
            error: "IList<ProcessColorSurfaceDto> cannot be empty."
          };
        case 5:
          orderDate = d.Parent.OrderDate; // let retDto = new ProcessColorSurfaceDto();
          retDto = {}; //Get the first Dto in the lst and put it
          //in the return dto. It is the default.
          retDto = d.ProcessColorSurfaces[0];
          m = "";
          _context4.next = 11;
          return getSortOrder({
            process: retDto.Process,
            sublineType: retDto.SublineType,
            orderDate: orderDate
          });
        case 11:
          retDto.HierarchySortOrder = _context4.sent;
          m = "ProcessId ";
          m += retDto.Process.toString();
          m += " SublineTypeId ";
          m += retDto.SublineType.toString();
          m += " Hierarchy is ";
          m += retDto.HierarchySortOrder.toString();
          x = 1;
        case 20:
          if (!(x <= d.ProcessColorSurfaces.length - 1)) {
            _context4.next = 37;
            break;
          }
          nextDto = d.ProcessColorSurfaces[x];
          _context4.next = 25;
          return getSortOrder({
            process: nextDto.Process,
            sublineType: nextDto.SublineType,
            orderDate: orderDate
          });
        case 25:
          nextDto.HierarchySortOrder = _context4.sent;
          m = "ProcessId ";
          m += nextDto.Process.toString();
          m += " SublineTypeId ";
          m += nextDto.SublineType.toString();
          m += " Hierarchy is ";
          m += nextDto.HierarchySortOrder.toString();
          if (nextDto.HierarchySortOrder < retDto.HierarchySortOrder) {
            m = "ProcessId ";
            m += nextDto.Process.toString();
            m += " SublineTypeId ";
            m += nextDto.SublineType.toString();
            m += " Hierarchy is higher priority. Make Primary. ";
            retDto = nextDto;
            // continue;
          }
          if (nextDto.SublineType == retDto.SublineType) {
            if (retDto.InstanceQuantity < nextDto.InstanceQuantity) {
              retDto = nextDto;
              // continue;
            }
          }
        case 34:
          x++;
          _context4.next = 20;
          break;
        case 37:
          return _context4.abrupt("return", retDto);
        case 38:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function findPrimaryProcessColorByHierarchy(_x4) {
    return _ref11.apply(this, arguments);
  };
}();
var getSortOrder = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref12) {
    var process, sublineType, orderDate, stid, prid, pricingSublineProcessHierarchyXRef, jsonContent, pp;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          process = _ref12.process, sublineType = _ref12.sublineType, orderDate = _ref12.orderDate;
          stid = sublineType;
          prid = process;
          pricingSublineProcessHierarchyXRef = pricer["PricingSublineProcessHierarchyXRef"];
          jsonContent = pricingSublineProcessHierarchyXRef;
          pp = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["PricingSublineProcessHierarchyXRef"]["ProcessId"]].toLowerCase() == prid.toLowerCase() && x[pricerFieldsIdx["PricingSublineProcessHierarchyXRef"]["SublineTypeId"]] == stid && x[pricerFieldsIdx["PricingSublineProcessHierarchyXRef"]["AvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["PricingSublineProcessHierarchyXRef"]["AvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["PricingSublineProcessHierarchyXRef"]["IsActive"]].toLowerCase() == "true";
          })[0];
          if (pp) {
            _context5.next = 8;
            break;
          }
          return _context5.abrupt("return", 99999);
        case 8:
          return _context5.abrupt("return", pp[pricerFieldsIdx["PricingSublineProcessHierarchyXRef"]["HierarchyOrder"]]);
        case 9:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getSortOrder(_x5) {
    return _ref13.apply(this, arguments);
  };
}();
var analyzeTextForPrimaryProcessDefault = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref16) {
    var d, hasText, i, s;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          d = _ref16.d;
          if (!(d.Sublines.Count <= 0)) {
            _context7.next = 3;
            break;
          }
          return _context7.abrupt("return");
        case 3:
          hasText = false;
          i = 0;
        case 5:
          if (!(i <= d.Sublines.length - 1)) {
            _context7.next = 15;
            break;
          }
          s = d.Sublines[i]; //If there is a s.UseAsPrimaryProcess, then
          //do nothing
          if (!(s.UseAsPrimaryProcess == true)) {
            _context7.next = 9;
            break;
          }
          return _context7.abrupt("return");
        case 9:
          if (!(s.SublineType == SublineType.TEXT)) {
            _context7.next = 12;
            break;
          }
          hasText = true;
          return _context7.abrupt("break", 15);
        case 12:
          i++;
          _context7.next = 5;
          break;
        case 15:
          //If you get this far, there is text but no
          //s.UseAsPrimaryProcess, so make the first text line primary.
          if (hasText) {
            d.Sublines[0].UseAsPrimaryProcess = true;
          }
        case 16:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function analyzeTextForPrimaryProcessDefault(_x7) {
    return _ref17.apply(this, arguments);
  };
}();

var isKit = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, kit;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          // console.log("Enter isKit.")
          //  let d = pricingDetail
          kit = false;
          if (d.KitParent || d.KitComponent) {
            // console.log("IsKit = true");
            kit = true;
          } else {
            // console.log("IsKit = false");
            kit = false;
          }
          return _context.abrupt("return", kit);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isKit(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var copyIntoPricingOrder = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var runDate, h, po, i, d, pd, j, s, ps, _j, _d, _j2, _d2;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          runDate = _ref3.runDate, h = _ref3.h;
          po = {
            Details: []
          };
          po.OrderDate = runDate;
          po.OrderNumber = h.OrderNumber;
          po.RefId = h.RefId;
          po.CustomerNumber = h.CustomerNumber;
          for (i = 0; i < h.Details.length; i++) {
            d = h.Details[i];
            d.Parent = h;
            d.allCharges = [];
            d.ProcessColorSurfaces = [];
            d.OrderAudits = [];
            pd = {
              Sublines: []
            };
            pd.Parent = h;
            pd.allCharges = [];
            pd.errors = [];
            pd.ProcessColorSurfaces = [];
            pd.OrderAudits = [];
            pd.KitComponent = d.KitComponent;
            pd.KitParent = d.KitParent;
            pd.OccasionId = d.OccasionId ? d.OccasionId.toString() : "";
            pd.OrderedItemNumber = d.OrderedItemNumber ? d.OrderedItemNumber.toString() : "";
            pd.Quantity = Number(d.Quantity);
            pd.RefId = d.RefId;
            pd.UseId = d.UseId ? d.UseId.toString() : "";
            pd.BrandId = d.BrandId ? d.BrandId.toString() : "";
            pd.AddLaserPowder = d.AddLaserPowder ? d.AddLaserPowder.toString() : "";
            pd.VerseId = d.VerseId ? d.VerseId.toString() : "";
            po.Details.push(pd);
            for (j = 0; j < d.Sublines.length; j++) {
              s = d.Sublines[j];
              s.Parent = d;
              ps = {};
              ps.Parent = d;
              ps.ColorId = s.ColorId ? s.ColorId.toString() : "";
              ps.PartId = s.PartId ? s.PartId.toString() : "";
              ps.Process = s.ProcessId ? s.ProcessId.toString() : "";
              ps.Quantity = Number(s.Quantity);
              ps.RefId = s.RefId;
              ps.RibbonTyingStyleId = s.RibbonTyingStyleId ? s.RibbonTyingStyleId.toString() : "";
              ps.SublineObjectDescription = s.SublineObjectDescription;
              ps.SublineObjectId = s.SublineObjectId ? s.SublineObjectId.toString() : "";
              ps.SublineObjectText = s.SublineObjectText;
              ps.SublineType = s.SublineTypeId ? s.SublineTypeId.toString() : "";
              ps.Surface = s.SurfaceId ? s.SurfaceId.toString() : "";
              ps.LetteringStyleId = s.LetteringStyleId ? s.LetteringStyleId.toString() : "";
              ps.BevelId = s.BevelId;
              pd.Sublines.push(ps);
            }
          }
          _j = 0;
        case 8:
          if (!(_j < po.Details.length)) {
            _context2.next = 15;
            break;
          }
          _d = po.Details[_j];
          _context2.next = 12;
          return fillMissing({
            d: _d
          });
        case 12:
          _j++;
          _context2.next = 8;
          break;
        case 15:
          _j2 = 0;
        case 16:
          if (!(_j2 < po.Details.length)) {
            _context2.next = 32;
            break;
          }
          _d2 = po.Details[_j2];
          _context2.prev = 18;
          _context2.next = 21;
          return determinePrimaryProcess({
            d: _d2
          });
        case 21:
          _context2.next = 29;
          break;
        case 23:
          _context2.prev = 23;
          _context2.t0 = _context2["catch"](18);
          console.log("error in determinePrimaryProcess ", _d2);
          _d2.errors.push({
            message: "Error in determinePrimaryProcess",
            errorDetails: _context2.t0,
            error: true
          });
          _context2.next = 29;
          return makeEmptyPrimaryProcess({
            d: _d2
          });
        case 29:
          _j2++;
          _context2.next = 16;
          break;
        case 32:
          return _context2.abrupt("return", po);
        case 33:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[18, 23]]);
  }));
  return function copyIntoPricingOrder(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var loadReturnObject = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var h, po, lst, i, d, pd;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          h = _ref5.h;
          if (!(h == null)) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", null);
        case 3:
          po = {};
          po.OrderAudits = [];
          po.RefId = h.RefId;
          lst = [];
          for (i = 0; i < h.Details.length; i++) {
            d = h.Details[i];
            pd = {};
            pd.RefId = d.RefId;
            pd.DetailAudits = [];
            pd.allCharges = d.allCharges;
            pd.OrderedItemNumber = d.OrderedItemNumber;
            pd.Quantity = Number(d.Quantity);
            pd.errors = d.errors;
            lst.push(pd);
          }
          if (lst.length > 0) {
            po.Details = lst;
          }
          return _context3.abrupt("return", po);
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function loadReturnObject(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var priceTotler = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
    var entity, i, _t, pd, j, c, t, k, d;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          entity = _ref8.entity;
          // console.log("Enter PriceTotaler.Evaluate");

          for (i = 0; i < entity.Details.length; i++) {
            _t = 0.00;
            pd = entity.Details[i];
            for (j = 0; j < pd.allCharges.length; j++) {
              c = pd.allCharges[j];
              if (typeof c.TheCharge != "undefined" && c.TheCharge != null) _t += Number(c.TheCharge);
            }
            pd.Total = _t;
          }
          t = 0.00;
          for (k = 0; k < entity.Details.length; k++) {
            d = entity.Details[k];
            t += d.Total;
          }
          entity.Total = t;
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function priceTotler(_x4) {
    return _ref9.apply(this, arguments);
  };
}();
var checkPCSEqual = function checkPCSEqual(a, b) {
  {
    if (a.Process == b.Process) {
      if (a.ColorId == b.ColorId) {
        if (a.Surface == b.Surface) {
          return true;
        }
      }
    }
    return false;
  }
};

var pricingDetail = {
  PricingSubline: [],
  refId: '',
  index: 0,
  orderDetailId: 0,
  orderedItemNumber: '',
  itemId: 0,
  albumId: 0,
  brandId: 0,
  quantity: 0,
  useId: 0,
  occasionId: 0,
  dieTypeId: 0,
  PricingOrder: {},
  kitParent: false,
  kitComponent: false,
  isDull: false,
  addLaserPowder: false,
  defaultProcessId: 0,
  commodityCode: '',
  verseId: 0,
  primaryProcessColorSurface: {},
  processColorSurfaces: [],
  allCharges: []
};

var AddCharge = function AddCharge(c, allCharges) {
  var i = getLastChargeId(allCharges);
  c.ChargeId = ++i;
  allCharges.push(c);
};
var getLastChargeId = function getLastChargeId(allCharges) {
  var i = 0;
  allCharges.forEach(function (c) {
    if (i < c.ChargeId) {
      i = c.ChargeId;
    }
  });
  return i;
};

var price$8 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, chg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          // console.log("Enter StockPricer.Price");
          // let chg = new Charge(ChargeType.Stock);
          chg = {};
          chg.ChargeType = ChargeType.Stock;
          chg.Description = "Stock Charge";
          chg.RefId = d.RefId;
          // modified
          // chg.TypeOfSubline = OMSLighteningBase.SublineType.NOTASUBLINE;
          chg.TypeOfSubline = SublineType.NOTASUBLINE;
          _context.prev = 6;
          _context.next = 9;
          return load({
            d: d,
            chg: chg
          });
        case 9:
          _context.next = 16;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](6);
          console.log("error in stock charge", _context.t0);
          d.errors.push({
            message: "Please check orderIemNumber/paper record present or not",
            errorDetails: _context.t0,
            error: true
          });
          // add charge
          // let pb = window.pricerRecordsDefault.ItemPriceBase;
          // let perTF = pb[pricerFieldsIdx["ItemPriceBase"]["PriceBasePer25"]]
          // let c = (d.Quantity / 25) * perTF;
          chg.TheCharge = 0.00;
        case 16:
          _context.next = 18;
          return AddCharge(chg, d.allCharges);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 11]]);
  }));
  return function price(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var load = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var d, chg, orderDate, perTF, item, pe, pb, c;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          d = _ref3.d, chg = _ref3.chg;
          // console.log("Enter StockPricer.load");
          orderDate = d.Parent.OrderDate;
          item = d.OrderedItemNumber;
          _context2.next = 5;
          return getItemPriceException({
            item: item,
            orderDate: orderDate
          });
        case 5:
          pe = _context2.sent;
          if (!(pe == null || pe == undefined)) {
            _context2.next = 17;
            break;
          }
          _context2.next = 9;
          return getItemPriceBase({
            item: item,
            orderDate: orderDate
          });
        case 9:
          pb = _context2.sent;
          if (!(pb == null)) {
            _context2.next = 14;
            break;
          }
          throw {
            error: "Cannot find ItemPriceBase or ItemPriceException." + item
          };
        case 14:
          perTF = pb[pricerFieldsIdx["ItemPriceBase"]["PriceBasePer25"]] ? pb[pricerFieldsIdx["ItemPriceBase"]["PriceBasePer25"]] : 0.00;
        case 15:
          _context2.next = 19;
          break;
        case 17:
          perTF = pe[pricerFieldsIdx["ItemPriceException"]["PriceExceptionPer25"]] ? pe[pricerFieldsIdx["ItemPriceException"]["PriceExceptionPer25"]] : 0.00;
          "Using Item Price Exception of " + perTF.toString(); // d.LogAudit( msg2, AuditType.INFO, AuditLevel.INFO, OrderLevel.DETAIL, PricingAuditSubsystem.StockPricer);
        case 19:
          c = d.Quantity / 25 * perTF; //  let msg3 = "Stock Price ((qty / 25) * " + perTF.toString() + ") is " + c.toString();
          //d.LogAudit( msg3, AuditType.ACTION, AuditLevel.INFO, OrderLevel.DETAIL, PricingAuditSubsystem.StockPricer);
          chg.TheCharge = c;
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function load(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var getItemPriceException = function getItemPriceException(_ref5) {
  var item = _ref5.item,
    orderDate = _ref5.orderDate;
  // console.log("Enter StockPricer.getItemPriceException");

  try {
    var itemPriceException = pricer["ItemPriceException"];
    var jsonContent = itemPriceException;
    var pe = jsonContent.filter(function (x) {
      return x[pricerFieldsIdx["ItemPriceException"]["OrderedItemNumber"]].toLowerCase() == item.toLowerCase() && x[pricerFieldsIdx["ItemPriceException"]["ItemPriceExceptionAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ItemPriceException"]["ItemPriceExceptionAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ItemPriceException"]["ItemPriceExceptionIsActive"]].toLowerCase() == 'true';
    })[0];
    return pe;
  } catch (error) {
    console.log("error in getItemPriceException ", error);
    return null;
    //throw error
  }
};
var getItemPriceBase = function getItemPriceBase(_ref6) {
  var item = _ref6.item,
    orderDate = _ref6.orderDate;
  try {
    var itemXRef = pricer["ItemXRef"];
    var jsonContent = itemXRef;
    var xit = jsonContent.filter(function (x) {
      return x[pricerFieldsIdx["ItemXRef"]["OrderedItemNumber"]].toLowerCase() == item.toLowerCase() && x[pricerFieldsIdx["ItemXRef"]["ItemAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ItemXRef"]["ItemAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ItemXRef"]["ItemIsActive"]].toLowerCase() == 'true';
    })[0];
    if (xit == null) {
      //xit = window.pricerRecordsDefault.ItemXRef;
      throw {
        error: "Cannot find ItemXRef record for OrderedItemNumber " + item
      };
    }
    var jde = xit[pricerFieldsIdx["ItemXRef"]["JDEShortItemNumber"]];
    var itemPriceBase = pricer["ItemPriceBase"];
    var itemPriceBaseJsonContent = itemPriceBase;
    var pb = itemPriceBaseJsonContent.filter(function (x) {
      return x[pricerFieldsIdx["ItemPriceBase"]["JDEShortItemNumber"]].toLowerCase() == jde.toLowerCase() && x[pricerFieldsIdx["ItemPriceBase"]["ItemPriceBaseAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ItemPriceBase"]["ItemPriceBaseAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ItemPriceBase"]["ItemPriceBaseIsActive"]].toLowerCase() == 'true';
    })[0];

    // if (!pb)
    //     pb = window.pricerRecordsDefault.ItemPriceBase;

    return pb;
  } catch (error) {
    console.log("error in getItemPriceBase ", error);
    return null;
    // throw error
  }
};

var getRateId = function getRateId(_ref) {
  var d = _ref.d;
  var occId = d.OccasionId;
  var useId = d.UseId;
  var occasionUseXref = pricer["OccasionUseXRef"];
  var oux = occasionUseXref.filter(function (x) {
    return x[pricerFieldsIdx["OccasionUseXRef"]["OccasionID"]].toLowerCase() == occId.toLowerCase() && x[pricerFieldsIdx["OccasionUseXRef"]["UseID"]].toLowerCase() == useId.toLowerCase();
  })[0];
  if (oux == null) {
    //  default value
    // oux = window.pricerRecordsDefault.OccasionUseXRef;

    throw {
      error: "No OccasionUseXRef record found for OccasionId" + occId.toString() + " UseId " + useId.toString()
    };
  }
  return oux[pricerFieldsIdx["OccasionUseXRef"]["RateID"]] ? oux[pricerFieldsIdx["OccasionUseXRef"]["RateID"]] : 0;
};

var price$7 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, chg, c;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          // if (d == null) {
          //     //  throw { error: "PricingOrderCarrierDto.PrimaryProcess property is null. You must set the Primary Process before calling this pricer." };
          // }
          // if (d.PrimaryProcessColorSurface.Process == Process.NONE) {
          //     //throw { error: "PricingOrderCarrierDto.PrimaryProcess.ProcessId is zero. It must be non-zero." };
          // }
          chg = {};
          chg.ChargeType = ChargeType.PrimaryPressRate;
          chg.RefId = d.RefId;
          chg.TypeOfSubline = SublineType.NOTASUBLINE;
          chg.Description = "Primary Press Rate";
          _context.prev = 6;
          _context.next = 9;
          return get$2({
            d: d
          });
        case 9:
          c = _context.sent;
          chg.TheCharge = c;
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](6);
          console.log("ERROR in primary press rate pricer", _context.t0);
          //throw error
        case 16:
          _context.next = 18;
          return AddCharge(chg, d.allCharges);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 13]]);
  }));
  return function price(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var get$2 = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var d, procId, qty, dt, i, amt;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          d = _ref3.d;
          procId = d.PrimaryProcessColorSurface.Process;
          qty = d.Quantity;
          dt = d.Parent.OrderDate;
          i = 0;
          amt = 0;
          if (procId) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return");
        case 8:
          _context2.prev = 8;
          _context2.next = 11;
          return getRateId({
            d: d
          });
        case 11:
          i = _context2.sent;
          if (!(i == 0)) {
            _context2.next = 15;
            break;
          }
          // throw { error: "No Rate record found." };
          d.errors.push({
            message: "Rate Id is not found please check occId:".concat(d.OccasionId, " useId:").concat(d.UseId, " based record in OccasionUseXRef"),
            errorDetails: null,
            error: true
          });
          return _context2.abrupt("return", amt);
        case 15:
          _context2.next = 22;
          break;
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](8);
          console.log("Rate Id is not found please check occId:".concat(d.OccasionId, " useId:").concat(d.UseId, " based record in OccasionUseXRef"), _context2.t0);
          d.errors.push({
            message: "Rate Id is not found please check occId:".concat(d.OccasionId, " useId:").concat(d.UseId, " based record in OccasionUseXRef"),
            errorDetails: _context2.t0,
            error: true
          });
          //throw
          return _context2.abrupt("return", amt);
        case 22:
          _context2.prev = 22;
          _context2.next = 25;
          return getRateAmount({
            rateId: i,
            processId: procId,
            quantity: qty,
            orderDate: dt
          });
        case 25:
          amt = _context2.sent;
          _context2.next = 33;
          break;
        case 28:
          _context2.prev = 28;
          _context2.t1 = _context2["catch"](22);
          console.log("Rate Id:".concat(i, " failed with processId:").concat(procId, " qty ").concat(qty, " date:").concat(dt, " in RateQuantity"), _context2.t1);
          d.errors.push({
            message: "Rate Id:".concat(i, " failed with processId:").concat(procId, " qty ").concat(qty, " date:").concat(dt, " in RateQuantity"),
            errorDetails: _context2.t1,
            error: true
          });
          // amt = window.pricerRecordsDefault.RateQuantity[pricerFieldsIdx["RateQuantity"]["RateAmount"]];
          return _context2.abrupt("return", amt);
        case 33:
          return _context2.abrupt("return", amt);
        case 34:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[8, 17], [22, 28]]);
  }));
  return function get(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var getRateAmount = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var rateId, processId, quantity, orderDate, ret, rq1;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          rateId = _ref5.rateId, processId = _ref5.processId, quantity = _ref5.quantity, orderDate = _ref5.orderDate;
          _context3.prev = 1;
          _context3.next = 4;
          return getRateQuantity({
            rateId: rateId,
            processId: processId,
            quantity: quantity,
            orderDate: orderDate
          });
        case 4:
          rq1 = _context3.sent;
          if (rq1) {
            _context3.next = 10;
            break;
          }
          _context3.next = 8;
          return extrapolateRateAmount({
            rateId: rateId,
            processId: processId,
            quantity: quantity,
            orderDate: orderDate
          });
        case 8:
          ret = _context3.sent;
          return _context3.abrupt("return", ret);
        case 10:
          _context3.next = 12;
          return isThisHighestRateQuantity({
            rq: rq1,
            orderDate: orderDate
          });
        case 12:
          if (!_context3.sent) {
            _context3.next = 17;
            break;
          }
          _context3.next = 15;
          return extrapolateRateAmount({
            rateId: rateId,
            processId: processId,
            quantity: quantity,
            orderDate: orderDate
          });
        case 15:
          ret = _context3.sent;
          return _context3.abrupt("return", ret);
        case 17:
          ret = rq1[pricerFieldsIdx["RateQuantity"]["RateAmount"]];
          return _context3.abrupt("return", ret);
        case 21:
          _context3.prev = 21;
          _context3.t0 = _context3["catch"](1);
          throw _context3.t0;
        case 24:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 21]]);
  }));
  return function getRateAmount(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var getRateQuantity = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var rateId, processId, quantity, orderDate, rateQuantity, am;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          rateId = _ref7.rateId, processId = _ref7.processId, quantity = _ref7.quantity, orderDate = _ref7.orderDate;
          _context4.prev = 1;
          rateQuantity = pricer["RateQuantity"];
          am = rateQuantity.filter(function (x) {
            if (x[pricerFieldsIdx["RateQuantity"]["RateID"]].toLowerCase() == rateId.toLowerCase() && x[pricerFieldsIdx["RateQuantity"]["ProcessID"]] == processId) {
              if (x[pricerFieldsIdx["RateQuantity"]["RateID"]].toLowerCase() == rateId.toLowerCase() && x[pricerFieldsIdx["RateQuantity"]["ProcessID"]] == processId && x[pricerFieldsIdx["RateQuantity"]["RateQuantityHigh"]] >= quantity && x[pricerFieldsIdx["RateQuantity"]["RateQuantityLow"]] <= quantity && x[pricerFieldsIdx["RateQuantity"]["RateQuantityAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["RateQuantity"]["RateQuantityAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["RateQuantity"]["RateQuantityIsActive"]].toLowerCase() == "true") {
                return x;
              }
            }
          })[0]; // if (!am)
          //     am = window.pricerRecordsDefault.RateQuantity;
          return _context4.abrupt("return", am);
        case 7:
          _context4.prev = 7;
          _context4.t0 = _context4["catch"](1);
          throw _context4.t0;
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 7]]);
  }));
  return function getRateQuantity(_x4) {
    return _ref8.apply(this, arguments);
  };
}();
var extrapolateRateAmount = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var rateId, processId, quantity, orderDate, r1, maxQty, r2, highRate, secondRate, secondCutoff, multi, rate;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          rateId = _ref9.rateId, processId = _ref9.processId, quantity = _ref9.quantity, orderDate = _ref9.orderDate;
          _context5.prev = 1;
          _context5.next = 4;
          return getHighestRateQuantity({
            rateId: rateId,
            processId: processId,
            orderDate: orderDate
          });
        case 4:
          r1 = _context5.sent;
          // let max = r1.RateQuantityHigh;
          maxQty = r1[pricerFieldsIdx["RateQuantity"]["RateQuantityHigh"]];
          _context5.next = 8;
          return getSecondHighestRateQuantity({
            maxQty: maxQty,
            rateId: rateId,
            processId: processId,
            orderDate: orderDate
          });
        case 8:
          r2 = _context5.sent;
          highRate = Number(r1[pricerFieldsIdx["RateQuantity"]["RateAmount"]]);
          secondRate = Number(r2[pricerFieldsIdx["RateQuantity"]["RateAmount"]]);
          secondCutoff = Number(r2[pricerFieldsIdx["RateQuantity"]["RateQuantityHigh"]]);
          multi = (Number(quantity) - secondCutoff) / secondCutoff;
          rate = highRate * multi + secondRate;
          rate = rate.toFixed(2);
          return _context5.abrupt("return", rate);
        case 18:
          _context5.prev = 18;
          _context5.t0 = _context5["catch"](1);
          throw _context5.t0;
        case 21:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 18]]);
  }));
  return function extrapolateRateAmount(_x5) {
    return _ref10.apply(this, arguments);
  };
}();
var isThisHighestRateQuantity = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
    var rq, orderDate, rqid, rateId, procId, rqh, rqhid, b;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          rq = _ref11.rq, orderDate = _ref11.orderDate;
          _context6.prev = 1;
          if (!(rq == null)) {
            _context6.next = 4;
            break;
          }
          return _context6.abrupt("return", false);
        case 4:
          if (rq[pricerFieldsIdx["RateQuantity"]["ProcessID"]]) {
            _context6.next = 6;
            break;
          }
          return _context6.abrupt("return", false);
        case 6:
          rqid = rq[pricerFieldsIdx["RateQuantity"]["RateQuantityID"]];
          rateId = rq[pricerFieldsIdx["RateQuantity"]["RateID"]];
          procId = rq[pricerFieldsIdx["RateQuantity"]["ProcessID"]];
          _context6.next = 12;
          return getHighestRateQuantity({
            rateId: rateId,
            processId: procId,
            orderDate: orderDate
          });
        case 12:
          rqh = _context6.sent;
          rqhid = rqh[pricerFieldsIdx["RateQuantity"]["RateQuantityID"]];
          b = rqid == rqhid;
          return _context6.abrupt("return", b);
        case 18:
          _context6.prev = 18;
          _context6.t0 = _context6["catch"](1);
          throw _context6.t0;
        case 21:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[1, 18]]);
  }));
  return function isThisHighestRateQuantity(_x6) {
    return _ref12.apply(this, arguments);
  };
}();
var getHighestRateQuantity = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13) {
    var rateId, processId, orderDate, rateQuantity, rqs, r;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          rateId = _ref13.rateId, processId = _ref13.processId, orderDate = _ref13.orderDate;
          _context7.prev = 1;
          rateQuantity = pricer["RateQuantity"];
          rqs = rateQuantity.filter(function (x) {
            return x[pricerFieldsIdx["RateQuantity"]["RateID"]].toLowerCase() == rateId.toLowerCase() && x[pricerFieldsIdx["RateQuantity"]["ProcessID"]].toLowerCase() == processId.toLowerCase() && x[pricerFieldsIdx["RateQuantity"]["RateQuantityAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["RateQuantity"]["RateQuantityAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["RateQuantity"]["RateQuantityIsActive"]].toLowerCase() == "true";
          }); // if (!rqs)
          //     rqs = window.pricerRecordsDefault.RateQuantity;
          r = rqs.sort(function (a, b) {
            return Number(b[pricerFieldsIdx["RateQuantity"]["RateQuantityHigh"]]) - Number(a[pricerFieldsIdx["RateQuantity"]["RateQuantityHigh"]]);
          });
          return _context7.abrupt("return", r[0]);
        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7["catch"](1);
          throw _context7.t0;
        case 11:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[1, 8]]);
  }));
  return function getHighestRateQuantity(_x7) {
    return _ref14.apply(this, arguments);
  };
}();
var getSecondHighestRateQuantity = function getSecondHighestRateQuantity(_ref15) {
  var maxQty = _ref15.maxQty,
    rateId = _ref15.rateId,
    processId = _ref15.processId,
    orderDate = _ref15.orderDate;
  try {
    var rateQuantity = pricer["RateQuantity"];
    var rqs = rateQuantity.filter(function (x) {
      return x[pricerFieldsIdx["RateQuantity"]["RateID"]].toLowerCase() == rateId.toLowerCase() && x[pricerFieldsIdx["RateQuantity"]["ProcessID"]].toLowerCase() == processId.toLowerCase() && x[pricerFieldsIdx["RateQuantity"]["RateQuantityAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["RateQuantity"]["RateQuantityAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["RateQuantity"]["RateQuantityIsActive"]].toLowerCase() == "true";
    });

    // default value
    // if (!rqs)
    //     rqs = window.pricerRecordsDefault.RateQuantity;

    var secondRate = rqs.filter(function (x) {
      return Number(x[pricerFieldsIdx["RateQuantity"]["RateQuantityHigh"]]) < Number(maxQty);
    }).sort(function (a, b) {
      return Number(b[pricerFieldsIdx["RateQuantity"]["RateQuantityHigh"]]) - Number(a[pricerFieldsIdx["RateQuantity"]["RateQuantityHigh"]]);
    });
    return secondRate[0];
  } catch (error) {
    throw error;
  }
};

// public void Price(PricingDetail d)
var price$6 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, chg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          // logr.Info("Enter DieChargePricer.Price");
          chg = {};
          chg.ChargeType = ChargeType.TextUpgrade;
          chg.RefId = d.RefId;
          chg.TypeOfSubline = SublineType.NOTASUBLINE;
          chg.Description = "Text Upgrade";
          _context.prev = 6;
          _context.next = 9;
          return getCharge({
            d: d,
            chg: chg
          });
        case 9:
          _context.next = 15;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](6);
          chg.TheCharge = 0.00;
          d.errors.push({
            message: "Error in gettiing text upgrade price",
            errorDetails: _context.t0,
            error: true
          });
        case 15:
          _context.next = 17;
          return AddCharge(chg, d.allCharges);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 11]]);
  }));
  return function price(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getCharge = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var d, chg, occId, useId, dt, procId, id, tr;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          d = _ref3.d, chg = _ref3.chg;
          _context2.prev = 1;
          occId = d.OccasionId;
          useId = d.UseId;
          dt = d.Parent.OrderDate;
          procId = d.PrimaryProcessColorSurface.Process.toString();
          if (procId) {
            _context2.next = 8;
            break;
          }
          throw "Process id not present";
        case 8:
          _context2.next = 10;
          return isTextUpgradeOverride({
            processId: procId,
            orderDate: dt,
            d: d
          });
        case 10:
          if (!_context2.sent) {
            _context2.next = 13;
            break;
          }
          // console.log( "TextUpgradeOverride true.")
          chg.TheCharge = 0.00;
          return _context2.abrupt("return");
        case 13:
          _context2.next = 15;
          return getTextUpgradeId({
            occId: occId,
            useId: useId
          });
        case 15:
          id = _context2.sent;
          if (!(id == null)) {
            _context2.next = 19;
            break;
          }
          // console.log({error: "OccasionUseXRef entry not found."})
          chg.TheCharge = 0.00;
          return _context2.abrupt("return");
        case 19:
          if (id) {
            _context2.next = 22;
            break;
          }
          // console.log({error : "OccasionUseXRef.TextUpgradeId is null."})
          chg.TheCharge = 0.00;
          return _context2.abrupt("return");
        case 22:
          _context2.next = 24;
          return getTextUpgradeRate({
            textUpgradeId: id,
            orderDate: dt
          });
        case 24:
          tr = _context2.sent;
          if (!(tr == null)) {
            _context2.next = 28;
            break;
          }
          // console.log({error : "TextUpgradeMaster not found."})
          chg.TheCharge = 0.00;
          return _context2.abrupt("return");
        case 28:
          if (tr) {
            _context2.next = 31;
            break;
          }
          // console.log({error: "TextUpgradeMaster Rate is null."});
          chg.TheCharge = 0.00;
          return _context2.abrupt("return");
        case 31:
          chg.TheCharge = tr;
          _context2.next = 38;
          break;
        case 34:
          _context2.prev = 34;
          _context2.t0 = _context2["catch"](1);
          chg.TheCharge = 0.00;
          d.errors.push({
            message: "text upgrade pricer failed",
            errorDetails: _context2.t0,
            error: true
          });
        case 38:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 34]]);
  }));
  return function getCharge(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var isTextUpgradeOverride = function isTextUpgradeOverride(_ref5) {
  var processId = _ref5.processId,
    orderDate = _ref5.orderDate,
    d = _ref5.d;
  var processMaster = pricer["ProcessMaster"];
  var jsonContent = processMaster;
  var pm = jsonContent.filter(function (x) {
    return x[pricerFieldsIdx["ProcessMaster"]["ProcessID"]].toLowerCase() == processId.toLowerCase() && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessIsActive"]].toLowerCase() == "true";
  })[0];
  if (pm == null) {
    d.errors.push({
      message: "Cannot find ProcessMaster entry for ProcessId ".concat(processId.toString(), " with order date ").concat(orderDate, " "),
      errorDetails: "Cannot find ProcessMaster entry for ProcessId ".concat(processId.toString(), " with order date ").concat(orderDate),
      error: true
    });
    // pm = window.pricerRecordsDefault.ProcessMaster;

    throw {
      error: "Cannot find ProcessMaster entry for ProcessId " + processId.toString()
    };
  }
  if (pm[pricerFieldsIdx["ProcessMaster"]["TextUpgradeOverride"]].toLowerCase() == "false") {
    return false;
  }

  // let b = pm.TextUpgradeOverride;
  // return b;
  return true;
};
var getTextUpgradeId = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
    var occId, useId, processMaster, jsonContent, oux;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          occId = _ref6.occId, useId = _ref6.useId;
          processMaster = pricer["OccasionUseXRef"];
          jsonContent = processMaster;
          oux = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["OccasionUseXRef"]["OccasionID"]].toLowerCase() == occId.toLowerCase() && x[pricerFieldsIdx["OccasionUseXRef"]["UseID"]].toLowerCase() == useId.toLowerCase();
          })[0];
          if (!(oux == null)) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return", null);
        case 6:
          if (!oux[pricerFieldsIdx["OccasionUseXRef"]["TextUpgradeID"]]) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return", oux[pricerFieldsIdx["OccasionUseXRef"]["TextUpgradeID"]]);
        case 8:
          return _context3.abrupt("return", null);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getTextUpgradeId(_x3) {
    return _ref7.apply(this, arguments);
  };
}();
var getTextUpgradeRate = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
    var textUpgradeId, orderDate, processMaster, jsonContent, txu, d;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          textUpgradeId = _ref8.textUpgradeId, orderDate = _ref8.orderDate;
          processMaster = pricer["TextUpgradeMaster"];
          jsonContent = processMaster;
          txu = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["TextUpgradeMaster"]["TextUpGradeID"]].toLowerCase() == textUpgradeId.toLowerCase() && x[pricerFieldsIdx["TextUpgradeMaster"]["TextUpGradeAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["TextUpgradeMaster"]["TextUpGradeAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["TextUpgradeMaster"]["TextUpGradeIsActive"]].toLowerCase() == "true";
          })[0];
          if (!(txu == null)) {
            _context4.next = 6;
            break;
          }
          return _context4.abrupt("return", null);
        case 6:
          d = txu[pricerFieldsIdx["TextUpgradeMaster"]["TextUpgradePrice"]];
          return _context4.abrupt("return", d);
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getTextUpgradeRate(_x4) {
    return _ref9.apply(this, arguments);
  };
}();

// public void Price(PricingDetail d)
var price$5 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, chg, pid, exists, r, dc;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          chg = {};
          chg.ChargeType = ChargeType.Die;
          chg.RefId = d.RefId;
          chg.TypeOfSubline = SublineType.NOTASUBLINE;
          chg.Description = "Die Charge";
          _context.prev = 6;
          if (!(d.PrimaryProcessColorSurface == null)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return");
        case 9:
          //There is a const called NUMBER OF FREE LINES. currently set to 5.
          //You apply the DieCharge. Then you apply the line by line charge for
          //each line over the NUMBER OF FREE LINES count.
          pid = d.PrimaryProcessColorSurface.Process;
          if (!(d.DieTypeId == 0)) {
            _context.next = 14;
            break;
          }
          _context.next = 13;
          return getDieChargeType({
            occasionId: d.OccasionId,
            useId: d.UseId,
            d: d
          });
        case 13:
          d.DieTypeId = _context.sent;
        case 14:
          //Does DieType and Process exist in DieTypeProcessXRef table.
          //If not, there is no die.
          exists = false;
          if (!(d.DieTypeId == 0)) {
            _context.next = 19;
            break;
          }
          exists = false;
          _context.next = 22;
          break;
        case 19:
          _context.next = 21;
          return doesDieTypeProcessComboExist({
            dieTypeId: d.DieTypeId,
            processId: pid
          });
        case 21:
          exists = _context.sent;
        case 22:
          if (exists) {
            _context.next = 24;
            break;
          }
          return _context.abrupt("return");
        case 24:
          _context.prev = 24;
          _context.next = 27;
          return getDieChargePriceRecord({
            dieTypeId: d.DieTypeId,
            primaryProcId: pid
          });
        case 27:
          r = _context.sent;
          dc = r[pricerFieldsIdx["DieTypeProcessXRef"]["DieTypePrice"]]; // let linedc = r[pricerFieldsIdx["DieTypeProcessXRef"]["DieChargePerLine"]];
          chg.TheCharge = dc;
          _context.next = 36;
          break;
        case 32:
          _context.prev = 32;
          _context.t0 = _context["catch"](24);
          chg.TheCharge = 0.00;
          d.errors.push({
            message: "Error in getting  die charge price record",
            errorDetails: _context.t0,
            error: true
          });
        case 36:
          _context.next = 42;
          break;
        case 38:
          _context.prev = 38;
          _context.t1 = _context["catch"](6);
          d.errors.push({
            message: "Error in die charge calcualtion",
            errorDetails: _context.t1,
            error: true
          });
          chg.TheCharge = 0.00;
        case 42:
          _context.next = 44;
          return AddCharge(chg, d.allCharges);
        case 44:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 38], [24, 32]]);
  }));
  return function price(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getDieChargeType = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var occasionId, useId, d, processMaster, jsonContent, oux, dtype;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          occasionId = _ref3.occasionId, useId = _ref3.useId, d = _ref3.d;
          _context2.prev = 1;
          processMaster = pricer["OccasionUseXRef"];
          jsonContent = processMaster;
          oux = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["OccasionUseXRef"]["OccasionID"]].toLowerCase() == occasionId.toLowerCase() && x[pricerFieldsIdx["OccasionUseXRef"]["UseID"]].toLowerCase() == useId.toLowerCase();
          })[0];
          if (!(oux == null)) {
            _context2.next = 8;
            break;
          }
          d.errors.push({
            message: "Cannot find OccasionUseXRef record for OccasionId ".concat(occasionId, " UseId ").concat(useId),
            errorDetails: null,
            error: true
          });

          //oux = window.pricerRecordsDefault.OccasionUseXRef;
          throw {
            error: "Cannot find OccasionUseXRef record for OccasionId " + occasionId.toString() + " UseId " + useId.toString()
          };
        case 8:
          dtype = oux[pricerFieldsIdx["OccasionUseXRef"]["DieTypeID"]] ? oux[pricerFieldsIdx["OccasionUseXRef"]["DieTypeID"]] : 0;
          return _context2.abrupt("return", dtype);
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](1);
          throw _context2.t0;
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 12]]);
  }));
  return function getDieChargeType(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var doesDieTypeProcessComboExist = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var dieTypeId, processId, processMaster, jsonContent, dx;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          dieTypeId = _ref5.dieTypeId, processId = _ref5.processId;
          // console.log("Enter DieChargePricer.doesDieTypeProcessComboExist");
          processMaster = pricer["DieTypeProcessXRef"];
          jsonContent = processMaster;
          dx = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["DieTypeProcessXRef"]["ProcessID"]] == processId && x[pricerFieldsIdx["DieTypeProcessXRef"]["DieTypeID"]].toLowerCase() == dieTypeId.toLowerCase();
          })[0];
          if (!(dx == null)) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return", false);
        case 6:
          return _context3.abrupt("return", true);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function doesDieTypeProcessComboExist(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var getDieChargePriceRecord = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var dieTypeId, primaryProcId, processMaster, jsonContent, r;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dieTypeId = _ref7.dieTypeId, primaryProcId = _ref7.primaryProcId;
          processMaster = pricer["DieTypeProcessXRef"];
          jsonContent = processMaster;
          r = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["DieTypeProcessXRef"]["ProcessID"]].toLowerCase() == primaryProcId.toLowerCase() && x[pricerFieldsIdx["DieTypeProcessXRef"]["DieTypeID"]].toLowerCase() == dieTypeId.toLowerCase();
          })[0];
          return _context4.abrupt("return", r);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getDieChargePriceRecord(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var price$4 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          _context.prev = 1;
          _context.next = 4;
          return setAPRs({
            d: d
          });
        case 4:
          _context.next = 9;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](1);
          // throw error
          d.errors.push({
            message: "Error in apr surcharge price calcuation",
            errorDetails: _context.t0,
            error: true
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 6]]);
  }));
  return function price(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var setAPRs = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var d;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          d = _ref3.d;
          _context2.prev = 1;
          _context2.next = 4;
          return calculateAPRSurcharges({
            d: d
          });
        case 4:
          _context2.next = 9;
          break;
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](1);
          throw _context2.t0;
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 6]]);
  }));
  return function setAPRs(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var calculateAPRSurcharges = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var d, orderDate, pcs, pp, dt, dig, chgId, i, p, retChg, rateId, rm;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          d = _ref5.d;
          _context3.prev = 1;
          if (!(d.ProcessColorSurfaces == null)) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return");
        case 4:
          if (!(d.PrimaryProcessColorSurface == null)) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return");
        case 6:
          orderDate = d.Parent.OrderDate;
          pcs = d.ProcessColorSurfaces;
          pp = d.PrimaryProcessColorSurface;
          dt = d.Parent.OrderDate;
          dig = false;
          chgId = 0;
          i = 0;
        case 14:
          if (!(i < pcs.length)) {
            _context3.next = 61;
            break;
          }
          p = pcs[i]; // let snip = "Process " + p.Process.toString() + " Color " + p.ColorId.toString();
          if (!checkPCSEqual(p, pp)) {
            _context3.next = 19;
            break;
          }
          return _context3.abrupt("continue", 58);
        case 19:
          _context3.next = 21;
          return isItDigital$1({
            p: p
          });
        case 21:
          if (!_context3.sent) {
            _context3.next = 25;
            break;
          }
          if (!dig) {
            _context3.next = 24;
            break;
          }
          return _context3.abrupt("continue", 58);
        case 24:
          dig = true;
        case 25:
          // console.log("Not Digital Process.")
          //    let  retChg=charge;
          retChg = {};
          retChg.Description = "APR Calculated";
          rateId = 0;
          _context3.prev = 28;
          _context3.next = 31;
          return getRateId({
            d: d
          });
        case 31:
          rateId = _context3.sent;
          _context3.next = 39;
          break;
        case 34:
          _context3.prev = 34;
          _context3.t0 = _context3["catch"](28);
          console.log("Rate Id is not found please check occId:".concat(d.OccasionId, " useId:").concat(d.UseId, " based record in OccasionUseXRef"), _context3.t0);
          d.errors.push({
            message: "Rate Id is not found please check occId:".concat(d.OccasionId, " useId:").concat(d.UseId, " based record in OccasionUseXRef"),
            errorDetails: _context3.t0,
            error: true
          });
          throw _context3.t0;
        case 39:
          _context3.next = 41;
          return getRateMaster({
            rateId: rateId,
            orderDate: orderDate
          });
        case 41:
          rm = _context3.sent;
          if (!(rm == null)) {
            _context3.next = 45;
            break;
          }
          d.errors.push({
            message: "Rate master record not found for rateId:".concat(rateId, " order date:").concat(orderDate),
            errorDetails: null,
            error: true
          });
          // rm = window.pricerRecordsDefault.RateMaster;
          throw "Rate master record not found for rateId:".concat(rateId, " order date:").concat(orderDate);
        case 45:
          if (!(rm[pricerFieldsIdx["RateMaster"]["RateBasedAPR"]].toLowerCase() == "true")) {
            _context3.next = 51;
            break;
          }
          _context3.next = 48;
          return getCalculatedAPR({
            d: d,
            rm: rm,
            p: p,
            orderDate: dt,
            chgId: chgId
          });
        case 48:
          retChg = _context3.sent;
          _context3.next = 54;
          break;
        case 51:
          _context3.next = 53;
          return getAPRForProcess({
            dto: p,
            orderDate: dt,
            chgId: chgId
          });
        case 53:
          retChg = _context3.sent;
        case 54:
          // let msg = "APR for Process " + p.Process.toString();
          // msg += " " + retChg.ChargeId.toString() + " " + retChg.Description + " " + retChg.TheCharge.toString();

          retChg.RefId = d.RefId;
          retChg.TypeOfSubline = SublineType.OMSAPR;
          _context3.next = 58;
          return AddCharge(retChg, d.allCharges);
        case 58:
          i++;
          _context3.next = 14;
          break;
        case 61:
          _context3.next = 66;
          break;
        case 63:
          _context3.prev = 63;
          _context3.t1 = _context3["catch"](1);
          throw _context3.t1;
        case 66:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 63], [28, 34]]);
  }));
  return function calculateAPRSurcharges(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

//TODO: The Press rate needs to be calculated based on the process for the actual APR.
//Also have to factor in the DieCharge. The old pricer is up to date on this. See that for guidance.
// private Charge getCalculatedAPR(PricingDetail d, RateMaster rm, ProcessColorSurfaceDto p, DateTime orderDate)
var getCalculatedAPR = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var d, rm, p, orderDate, chgId, chg, theProcessId, pressRate, calc, hasDieCharge, dieCharge, theDieTypeId, isDieChargeCombo, dtx;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          d = _ref7.d, rm = _ref7.rm, p = _ref7.p, orderDate = _ref7.orderDate, chgId = _ref7.chgId;
          chg = {};
          chg.Description = "APR Calculated Based On PressRate";
          _context4.prev = 3;
          theProcessId = p.Process;
          _context4.next = 7;
          return getPressRateForThisDetail({
            d: d
          });
        case 7:
          pressRate = _context4.sent;
          calc = rm[pricerFieldsIdx["RateMaster"]["APRCalculation"]] ? rm[pricerFieldsIdx["RateMaster"]["APRCalculation"]] : 0.00;
          hasDieCharge = false;
          dieCharge = 0.00;
          theDieTypeId = 0;
          if (!(d.DieTypeId == 0)) {
            _context4.next = 18;
            break;
          }
          _context4.next = 15;
          return getDieChargeType({
            occasionId: d.OccasionId,
            useId: d.UseId,
            d: d
          });
        case 15:
          theDieTypeId = _context4.sent;
          _context4.next = 19;
          break;
        case 18:
          theDieTypeId = d.DieTypeId;
        case 19:
          _context4.next = 21;
          return doesDieTypeProcessComboExist({
            dieTypeId: theDieTypeId,
            processId: theProcessId
          });
        case 21:
          isDieChargeCombo = _context4.sent;
          if (!isDieChargeCombo) {
            _context4.next = 28;
            break;
          }
          _context4.next = 25;
          return getDieChargePriceRecord({
            dieTypeId: theDieTypeId,
            primaryProcId: theProcessId
          });
        case 25:
          dtx = _context4.sent;
          dieCharge = dtx.DieTypePrice;
          if (dieCharge > 0) {
            hasDieCharge = true;
          }
        case 28:
          if (!hasDieCharge) {
            _context4.next = 34;
            break;
          }
          _context4.next = 31;
          return getAPRWithDieCalculatedFromPressRate({
            aprCalculation: calc,
            pressRate: pressRate,
            proc: p.Process,
            colorId: p.ColorId,
            sType: p.SublineType,
            surf: p.Surface,
            orderDate: orderDate,
            dieCharge: dieCharge,
            chgId: chgId
          });
        case 31:
          chg = _context4.sent;
          _context4.next = 37;
          break;
        case 34:
          _context4.next = 36;
          return getAPRNoDieCalculatedFromPressRate({
            aprCalculation: calc,
            pressRate: pressRate,
            proc: p.Process,
            colorId: p.ColorId,
            sType: p.SublineType,
            surf: p.Surface,
            orderDate: orderDate,
            chgId: chgId
          });
        case 36:
          chg = _context4.sent;
        case 37:
          _context4.next = 42;
          break;
        case 39:
          _context4.prev = 39;
          _context4.t0 = _context4["catch"](3);
          throw _context4.t0;
        case 42:
          return _context4.abrupt("return", chg);
        case 43:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[3, 39]]);
  }));
  return function getCalculatedAPR(_x4) {
    return _ref8.apply(this, arguments);
  };
}();
var isItDigital$1 = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var p;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          p = _ref9.p;
          if (!(p.Process == Process.D)) {
            _context5.next = 3;
            break;
          }
          return _context5.abrupt("return", true);
        case 3:
          if (!(p.Process == Process.G)) {
            _context5.next = 5;
            break;
          }
          return _context5.abrupt("return", true);
        case 5:
          if (!(p.Process == Process.X)) {
            _context5.next = 7;
            break;
          }
          return _context5.abrupt("return", true);
        case 7:
          return _context5.abrupt("return", false);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function isItDigital(_x5) {
    return _ref10.apply(this, arguments);
  };
}();
var getPressRateForThisDetail = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
    var d, p, ch;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          d = _ref11.d;
          p = d.allCharges.filter(function (x) {
            return x.ChargeType == ChargeType.PrimaryPressRate;
          })[0];
          if (!(p == null)) {
            _context6.next = 4;
            break;
          }
          throw {
            error: "Cannot find PrimaryPressRate for this detail: " + d.RefId.toString()
          };
        case 4:
          ch = p.TheCharge;
          return _context6.abrupt("return", ch);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getPressRateForThisDetail(_x6) {
    return _ref12.apply(this, arguments);
  };
}();
var getRateMaster = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13) {
    var rateId, orderDate, rateMaster, jsonContent, rm;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          rateId = _ref13.rateId, orderDate = _ref13.orderDate;
          rateMaster = pricer["RateMaster"];
          jsonContent = rateMaster;
          rm = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["RateMaster"]["RateID"]].toLowerCase() == rateId.toLowerCase() && x[pricerFieldsIdx["RateMaster"]["RateAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["RateMaster"]["RateAvailabilityEnd"]] >= orderDate;
          })[0];
          return _context7.abrupt("return", rm);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getRateMaster(_x7) {
    return _ref14.apply(this, arguments);
  };
}();
var getAPRForProcess = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17) {
    var dto, orderDate, chgId, chg, soid, proc, colorId, surf, sType, sm, smtid;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          dto = _ref17.dto, orderDate = _ref17.orderDate, chgId = _ref17.chgId;
          _context9.prev = 1;
          // console.log("Enter APRSurchargePricer.getAPRForProcess")
          chg = {};
          chg.Description = "APR Calculated";
          //is it supplied die
          soid = dto.SublineObjectId;
          proc = dto.Process;
          colorId = dto.ColorId;
          surf = dto.Surface;
          sType = dto.SublineType;
          if (!(dto.SublineType == SublineType.SUPPLIED)) {
            _context9.next = 20;
            break;
          }
          _context9.next = 12;
          return getSuppliedMaterialDetail$1({
            sublineObjectId: soid,
            orderDate: orderDate,
            chgId: chgId
          });
        case 12:
          sm = _context9.sent;
          if (!sm) {
            _context9.next = 20;
            break;
          }
          smtid = sm[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialTypeID"]];
          if (!(smtid == 20)) {
            _context9.next = 20;
            break;
          }
          _context9.next = 18;
          return getAPRNoDie({
            proc: proc,
            colorId: colorId,
            sType: sType,
            surf: surf,
            orderDate: orderDate,
            chgId: chgId
          });
        case 18:
          chg = _context9.sent;
          return _context9.abrupt("return", chg);
        case 20:
          _context9.next = 22;
          return getAPRWithDie({
            proc: proc,
            colorId: colorId,
            sType: sType,
            surf: surf,
            orderDate: orderDate,
            chgId: chgId
          });
        case 22:
          chg = _context9.sent;
          return _context9.abrupt("return", chg);
        case 26:
          _context9.prev = 26;
          _context9.t0 = _context9["catch"](1);
          throw _context9.t0;
        case 29:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[1, 26]]);
  }));
  return function getAPRForProcess(_x9) {
    return _ref18.apply(this, arguments);
  };
}();
var getSuppliedMaterialDetail$1 = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref21) {
    var sublineObjectId, orderDate, suppliedMaterialDetail, jsonContent, sm;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          sublineObjectId = _ref21.sublineObjectId, orderDate = _ref21.orderDate;
          // console.log("Enter APRSurchargePricer.getSuppliedMaterialDetail");
          suppliedMaterialDetail = pricer["SuppliedMaterialDetail"];
          jsonContent = suppliedMaterialDetail;
          sm = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialID"]].toLowerCase() == sublineObjectId.toLowerCase() && x[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialIsActive"]].toLowerCase() == "true";
          })[0];
          return _context11.abrupt("return", sm);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getSuppliedMaterialDetail(_x11) {
    return _ref22.apply(this, arguments);
  };
}();
var getAPRWithDie = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref23) {
    var proc, colorId, sType, surf, orderDate, chgId, chg, processMaster, jsonContent, p;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          proc = _ref23.proc, colorId = _ref23.colorId, sType = _ref23.sType, surf = _ref23.surf, orderDate = _ref23.orderDate, chgId = _ref23.chgId;
          _context12.prev = 1;
          chg = {};
          chg.Description = "APR With Die Surcharge for SublineType " + sType + " process " + proc + " ColorId " + colorId + " Surface " + surf;
          chg.ChargeType = ChargeType.APRSurchargeWithDie;
          processMaster = pricer["ProcessMaster"];
          jsonContent = processMaster;
          p = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["ProcessMaster"]["ProcessID"]].toLowerCase() == proc.toLowerCase() && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessIsActive"]].toLowerCase() == "true";
          })[0];
          chg.ChargeId = chgId++;
          if (p) {
            chg.TheCharge = p[pricerFieldsIdx["ProcessMaster"]["AddlPressRunWithDie"]] ? p[pricerFieldsIdx["ProcessMaster"]["AddlPressRunWithDie"]] : 0.00;
            chg.Description = "APR With Die Surcharge for SublineType " + sType + " process " + proc + " ColorId " + colorId + " Surface " + surf;
          } else {
            chg.TheCharge = 0.00;
          }
          chg.TypeOfSubline = SublineType.OMSAPR;
          return _context12.abrupt("return", chg);
        case 14:
          _context12.prev = 14;
          _context12.t0 = _context12["catch"](1);
          throw _context12.t0;
        case 17:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[1, 14]]);
  }));
  return function getAPRWithDie(_x12) {
    return _ref24.apply(this, arguments);
  };
}();
var getAPRNoDie = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref25) {
    var proc, colorId, sType, surf, orderDate, chgId, chg, processMaster, jsonContent, p;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          proc = _ref25.proc, colorId = _ref25.colorId, sType = _ref25.sType, surf = _ref25.surf, orderDate = _ref25.orderDate, chgId = _ref25.chgId;
          _context13.prev = 1;
          chg = {};
          chg.Description = "APR No Die Surcharge for SublineType " + sType + " process " + proc + " ColorId " + colorId + " Surface " + surf;
          chg.ChargeType = ChargeType.APRSurchargeNoDie;
          processMaster = pricer["ProcessMaster"];
          jsonContent = processMaster;
          p = jsonContent.filte(function (x) {
            return x[pricerFieldsIdx["ProcessMaster"]["ProcessID"]].toLowerCase() == proc.toLowerCase() && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessIsActive"]].toLowerCase() == "true";
          })[0];
          chg.ChargeId = chgId++;
          if (p) {
            chg.TheCharge = p[pricerFieldsIdx["ProcessMaster"]["AddlPressRunNoDie"]] ? p[pricerFieldsIdx["ProcessMaster"]["AddlPressRunNoDie"]] : 0.00;
            chg.Description = "APR No Die Surcharge for SublineType " + sType + " process " + proc + " ColorId " + colorId + " Surface " + surf;
          } else {
            chg.TheCharge = 0.00;
          }
          chg.TypeOfSubline = SublineType.OMSAPR;
          return _context13.abrupt("return", chg);
        case 14:
          _context13.prev = 14;
          _context13.t0 = _context13["catch"](1);
          throw _context13.t0;
        case 17:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[1, 14]]);
  }));
  return function getAPRNoDie(_x13) {
    return _ref26.apply(this, arguments);
  };
}();
var getAPRWithDieCalculatedFromPressRate = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref27) {
    var aprCalculation, pressRate, dieCharge, chgId, chg, c;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          aprCalculation = _ref27.aprCalculation, pressRate = _ref27.pressRate, _ref27.proc, _ref27.colorId, _ref27.orderDate, dieCharge = _ref27.dieCharge, chgId = _ref27.chgId;
          // console.log("Enter APRSurchargePricer.getAPRCalculatedFromPressRate");
          chg = {};
          chg.ChargeId = chgId++;
          chg.Description = "APR Calculated Based On PressRate";
          chg.TypeOfSubline = SublineType.OMSAPR;
          chg.TypeOfCalculation = SurchargeCalculationType.QTY;
          if (!(aprCalculation == 0)) {
            _context14.next = 8;
            break;
          }
          throw {
            error: "aprCalculation cannot be zero."
          };
        case 8:
          if (!(pressRate == 0)) {
            _context14.next = 10;
            break;
          }
          throw {
            error: "pressRate cannot be zero"
          };
        case 10:
          c = pressRate * aprCalculation + dieCharge;
          chg.TheCharge = c;
          return _context14.abrupt("return", chg);
        case 13:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function getAPRWithDieCalculatedFromPressRate(_x14) {
    return _ref28.apply(this, arguments);
  };
}();
var getAPRNoDieCalculatedFromPressRate = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref29) {
    var aprCalculation, pressRate, chgId, chg, c;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          aprCalculation = _ref29.aprCalculation, pressRate = _ref29.pressRate, _ref29.proc, _ref29.colorId, _ref29.sType, _ref29.surf, _ref29.orderDate, chgId = _ref29.chgId;
          // // console.log("Enter APRSurchargePricer.getAPRCalculatedFromPressRate");
          // console.log("Enter APRSurchargePricer.getAPRCalculatedFromPressRate");
          // var chg = new Charge(ChargeType.CalculatedAPRSurchargeNoDie);
          chg = {};
          chg.ChargeType = ChargeType.CalculatedAPRSurchargeNoDie;
          chg.ChargeId = chgId++;
          chg.Description = "APR Calculated Based On PressRate";
          chg.TypeOfSubline = SublineType.OMSAPR;
          chg.TypeOfCalculation = SurchargeCalculationType.QTY;
          if (!(aprCalculation == 0)) {
            _context15.next = 9;
            break;
          }
          throw {
            error: "aprCalculation cannot be zero."
          };
        case 9:
          if (!(pressRate == 0)) {
            _context15.next = 11;
            break;
          }
          throw {
            error: "pressRate cannot be zero"
          };
        case 11:
          c = pressRate * aprCalculation;
          chg.TheCharge = c;
          return _context15.abrupt("return", chg);
        case 14:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function getAPRNoDieCalculatedFromPressRate(_x15) {
    return _ref30.apply(this, arguments);
  };
}();

// public void Price(PricingDetail d)
var price$3 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          _context.prev = 1;
          _context.next = 4;
          return setOCAs({
            d: d
          });
        case 4:
          _context.next = 9;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](1);
          // console.log("error in oca",error);
          // throw error;
          d.errors.push({
            message: "Error in oca surcharge price calcuation",
            errorDetails: _context.t0,
            error: true
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 6]]);
  }));
  return function price(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var setOCAs = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var d, primarySurface;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          d = _ref3.d;
          _context2.prev = 1;
          primarySurface = d.PrimaryProcessColorSurface.Surface;
          _context2.next = 5;
          return calculateOCASurcharges({
            d: d,
            surf: primarySurface
          });
        case 5:
          _context2.next = 10;
          break;
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](1);
          throw _context2.t0;
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 7]]);
  }));
  return function setOCAs(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var calculateOCASurcharges = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var d, surf, pcs, pp, dt, dig, chgId, i, p, chg, msg;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          d = _ref5.d, surf = _ref5.surf;
          _context3.prev = 1;
          pcs = d.ProcessColorSurfaces;
          pp = d.PrimaryProcessColorSurface;
          dt = d.Parent.OrderDate;
          dig = false;
          chgId = 0;
          i = 0;
        case 9:
          if (!(i < pcs.length)) {
            _context3.next = 34;
            break;
          }
          p = pcs[i];
          chg = {};
          chg.Description = "OCA With Die Surcharge for process " + p;
          if (!checkPCSEqual(p, pp)) {
            _context3.next = 16;
            break;
          }
          return _context3.abrupt("continue", 31);
        case 16:
          if (!(p.Surface == surf)) {
            _context3.next = 18;
            break;
          }
          return _context3.abrupt("continue", 31);
        case 18:
          _context3.next = 20;
          return isItDigital({
            p: p
          });
        case 20:
          if (!_context3.sent) {
            _context3.next = 24;
            break;
          }
          if (!dig) {
            _context3.next = 23;
            break;
          }
          return _context3.abrupt("continue", 31);
        case 23:
          dig = true;
        case 24:
          _context3.next = 26;
          return getOCAForProcess({
            dto: p,
            orderDate: dt,
            chgId: chgId
          });
        case 26:
          chg = _context3.sent;
          msg = "OCA for Process " + p.Process.toString();
          msg += " " + chg.ChargeId.toString() + " " + chg.Description + " " + chg.TheCharge.toString();
          // console.log("oca msg",msg);
          _context3.next = 31;
          return AddCharge(chg, d.allCharges);
        case 31:
          i++;
          _context3.next = 9;
          break;
        case 34:
          _context3.next = 39;
          break;
        case 36:
          _context3.prev = 36;
          _context3.t0 = _context3["catch"](1);
          throw _context3.t0;
        case 39:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 36]]);
  }));
  return function calculateOCASurcharges(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var isItDigital = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var p;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          p = _ref7.p;
          if (!(p.Process == Process.D)) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return", true);
        case 3:
          if (!(p.Process == Process.G)) {
            _context4.next = 5;
            break;
          }
          return _context4.abrupt("return", true);
        case 5:
          if (!(p.Process == Process.X)) {
            _context4.next = 7;
            break;
          }
          return _context4.abrupt("return", true);
        case 7:
          return _context4.abrupt("return", false);
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function isItDigital(_x4) {
    return _ref8.apply(this, arguments);
  };
}();
var getOCAForProcess = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var dto, orderDate, chgId, chg, soid, proc, sm, smtid;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          dto = _ref9.dto, orderDate = _ref9.orderDate, chgId = _ref9.chgId;
          // console.log("Enter OCASurchargePricer.getOCAForProcess");
          chg = {};
          _context5.prev = 2;
          soid = dto.SublineObjectId;
          proc = dto.Process;
          chg.Description = "OCA With Die Surcharge for process " + proc;
          if (!(dto.SublineType == SublineType.SUPPLIED)) {
            _context5.next = 17;
            break;
          }
          _context5.next = 9;
          return getSuppliedMaterialDetail({
            sublineObjectId: soid,
            orderDate: orderDate,
            chgId: chgId
          });
        case 9:
          sm = _context5.sent;
          if (!(sm != null)) {
            _context5.next = 17;
            break;
          }
          smtid = sm[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialTypeID"]];
          if (!(smtid == 20)) {
            _context5.next = 17;
            break;
          }
          _context5.next = 15;
          return getOCAWithDie({
            proc: proc,
            orderDate: orderDate,
            chgId: chgId
          });
        case 15:
          chg = _context5.sent;
          return _context5.abrupt("return", chg);
        case 17:
          _context5.next = 19;
          return getOCANoDie({
            proc: proc,
            orderDate: orderDate,
            chgId: chgId
          });
        case 19:
          chg = _context5.sent;
          _context5.next = 25;
          break;
        case 22:
          _context5.prev = 22;
          _context5.t0 = _context5["catch"](2);
          throw _context5.t0;
        case 25:
          //is it supplied die
          chg.TypeOfSubline = SublineType.OMSOCA;
          return _context5.abrupt("return", chg);
        case 27:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[2, 22]]);
  }));
  return function getOCAForProcess(_x5) {
    return _ref10.apply(this, arguments);
  };
}();
var getSuppliedMaterialDetail = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
    var sublineObjectId, orderDate, suppliedMaterialDetail, jsonContent, sm;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          sublineObjectId = _ref11.sublineObjectId, orderDate = _ref11.orderDate;
          // console.log("Enter OCASurchargePricer.getSuppliedMaterialDetail");
          suppliedMaterialDetail = pricer["SuppliedMaterialDetail"];
          jsonContent = suppliedMaterialDetail;
          sm = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialID"]].toLowerCase() == sublineObjectId.toLowerCase() && x[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["SuppliedMaterialDetail"]["SuppliedMaterialIsActive"]].toLowerCase() == "true";
          })[0];
          return _context6.abrupt("return", sm);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getSuppliedMaterialDetail(_x6) {
    return _ref12.apply(this, arguments);
  };
}();
var getOCAWithDie = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13) {
    var proc, orderDate, chgId, chg, processMaster, jsonContent, p;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          proc = _ref13.proc, orderDate = _ref13.orderDate, chgId = _ref13.chgId;
          _context7.prev = 1;
          chg = {};
          chg.Description = "OCA With Die Surcharge for process " + proc;
          chg.ChargeType = ChargeType.OCASurchargeWithDie;
          processMaster = pricer["ProcessMaster"];
          jsonContent = processMaster;
          p = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["ProcessMaster"]["ProcessID"]].toLowerCase() == proc.toLowerCase() && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessIsActive"]].toLowerCase() == "true";
          })[0];
          chg.ChargeId = chgId++;
          if (p) {
            chg.TheCharge = p[pricerFieldsIdx["ProcessMaster"]["AddlPressRunWithDie"]] ? p[pricerFieldsIdx["ProcessMaster"]["AddlPressRunWithDie"]] : 0.0;
          } else {
            chg.TheCharge = 0.00;
          }
          chg.Description = "OCA With Die Surcharge for process " + proc.toString();
          chg.TypeOfSubline = SublineType.OMSOCA;
          return _context7.abrupt("return", chg);
        case 15:
          _context7.prev = 15;
          _context7.t0 = _context7["catch"](1);
          throw _context7.t0;
        case 18:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[1, 15]]);
  }));
  return function getOCAWithDie(_x7) {
    return _ref14.apply(this, arguments);
  };
}();
var getOCANoDie = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref15) {
    var proc, orderDate, chgId, chg, processMaster, jsonContent, p;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          proc = _ref15.proc, orderDate = _ref15.orderDate, chgId = _ref15.chgId;
          _context8.prev = 1;
          chg = {};
          chg.Description = "OCA Without Die Surcharge for process " + proc;
          processMaster = pricer["ProcessMaster"];
          jsonContent = processMaster;
          p = jsonContent.filter(function (x) {
            return x[pricerFieldsIdx["ProcessMaster"]["ProcessID"]].toLowerCase() == proc.toLowerCase() && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ProcessMaster"]["ProcessIsActive"]].toLowerCase() == "true";
          })[0];
          chg.ChargeId = chgId++;
          if (p) {
            chg.TheCharge = p[pricerFieldsIdx["ProcessMaster"]["AddlPressRunNoDie"]] ? p[pricerFieldsIdx["ProcessMaster"]["AddlPressRunNoDie"]] : 0.0;
          } else {
            chg.TheCharge = 0.00;
          }
          chg.Description = "OCA No Die Surcharge for process " + proc.toString();
          chg.TypeOfSubline = SublineType.OMSOCA;
          return _context8.abrupt("return", chg);
        case 14:
          _context8.prev = 14;
          _context8.t0 = _context8["catch"](1);
          throw _context8.t0;
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[1, 14]]);
  }));
  return function getOCANoDie(_x8) {
    return _ref16.apply(this, arguments);
  };
}();

var isThisMultiPartSubline = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var s;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          s = _ref.s;
          if (!(Number(s.PartId) > 1)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", true);
        case 3:
          return _context.abrupt("return", false);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isThisMultiPartSubline(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var price$2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, i, s, chg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          i = 0;
        case 2:
          if (!(i < d.Sublines.length)) {
            _context.next = 26;
            break;
          }
          s = d.Sublines[i]; // console.log("Start SurchargePricer run for Detail " + d.RefId + " Subline " + s.RefId.toString());
          //TODO: Checks for two part sublines
          //such as BleedMotif Part 1 and Part 2.
          _context.prev = 4;
          _context.next = 7;
          return isThisMultiPartSubline({
            s: s
          });
        case 7:
          if (!_context.sent) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("continue", 23);
        case 9:
          _context.next = 11;
          return get$1({
            s: s
          });
        case 11:
          chg = _context.sent;
          if (chg) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("continue", 23);
        case 14:
          chg.RefId = d.RefId;
          _context.next = 17;
          return AddCharge(chg, d.allCharges);
        case 17:
          _context.next = 23;
          break;
        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](4);
          console.log("error in surcharge", _context.t0);
          d.errors.push({
            message: "Error in surcharge price calcuation",
            errorDetails: _context.t0,
            error: true
          });

          // throw error
          // need to check
          //  continue;
        case 23:
          i++;
          _context.next = 2;
          break;
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 19]]);
  }));
  return function price(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var get$1 = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var s, price, dt, qty, sm, sid, styp, chg, sf, _chg, sfq, qv, _chg2;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          s = _ref3.s;
          price = 0.00;
          dt = s.Parent.Parent.OrderDate;
          qty = 0; // console.log("SublineType is " + s.SublineType.toString())
          if (isSublineASurcharge({
            sb: s
          })) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", null);
        case 6:
          _context2.next = 8;
          return getSurchargeMaster({
            s: s,
            orderDate: dt
          });
        case 8:
          sm = _context2.sent;
          if (!(sm == null)) {
            _context2.next = 11;
            break;
          }
          return _context2.abrupt("return", null);
        case 11:
          sid = sm[pricerFieldsIdx["SurchargeMaster"]["SurchargeID"]];
          styp = sm[pricerFieldsIdx["SurchargeMaster"]["SurchargeTypeID"]]; // console.logt("SurchargeId is " + sid.toString() + " and SurchargeType is " + styp)
          if (!(s.SublineType == SublineType.ADHOC)) {
            _context2.next = 19;
            break;
          }
          _context2.next = 16;
          return makeSurcharge({
            s: s,
            price: s.AdHocPrice,
            sm: sm
          });
        case 16:
          chg = _context2.sent;
          chg.TypeOfSubline = SublineType.ADHOC;
          return _context2.abrupt("return", chg);
        case 19:
          if (!(styp == SurchargeCalculationType.FLAT)) {
            _context2.next = 30;
            break;
          }
          _context2.next = 22;
          return getSurchargeFlat({
            surchargeId: sid
          });
        case 22:
          sf = _context2.sent;
          //make flat surcharge
          price = sf.FlatPrice;
          // console.log("Surcharge Flat Price is " + price.toString())
          _context2.next = 26;
          return makeSurcharge({
            s: s,
            price: price,
            sm: sm
          });
        case 26:
          _chg = _context2.sent;
          _chg.TypeOfCalculation = SurchargeCalculationType.FLAT;
          _chg.TypeOfSubline = SublineType.OMSREG;
          return _context2.abrupt("return", _chg);
        case 30:
          if (!(styp == SurchargeCalculationType.QTY)) {
            _context2.next = 44;
            break;
          }
          _context2.next = 33;
          return getSurchargeQuantity({
            surchargeId: sid
          });
        case 33:
          sfq = _context2.sent;
          // console.log("Surcharge Quantity is " + sfq.SurchargeQuantityID.toString())
          qty = s.Parent.Quantity;
          qv = sfq.QuantityValue ? sfq.QuantityValue : 25; // console.log("Surcharge Quantity Value is " + qv.toString())
          if (sfq.MinimumQuantity) {
            if (Number(sfq.MinimumQuantity) > 0) {
              // console.log("Surcharge Quantity Minimum Value is " + sfq.MinimumQuantity.Value.toString())

              if (qty < Number(sfq.MinimumQuantity)) {
                qty = Number(sfq.MinimumQuantity);
              }
            }
          }

          // decimal
          price = (qty / qv * sfq.QuantityPrice).toFixed(2);

          // console.log("Price " + price.toString() + " = (" + qty + "/" + qv + ") * " + sfq.QuantityPrice.toString())
          _context2.next = 40;
          return makeSurcharge({
            s: s,
            price: price,
            sm: sm
          });
        case 40:
          _chg2 = _context2.sent;
          _chg2.TypeOfCalculation = SurchargeCalculationType.QTY;
          _chg2.TypeOfSubline = SublineType.OMSREG;
          return _context2.abrupt("return", _chg2);
        case 44:
          return _context2.abrupt("return", null);
        case 45:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function get(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var isSublineASurcharge = function isSublineASurcharge(_ref5) {
  var sb = _ref5.sb;
  if (sb.SublineType == SublineType.OMSSEL) {
    return true;
  }
  if (sb.SublineType == SublineType.OMSEXC) {
    return true;
  }
  if (sb.SublineType == SublineType.OMSREG) {
    return true;
  }
  if (sb.SublineType == SublineType.ADHOC) {
    return true;
  }
  return false;
};
var getSurchargeMaster = function getSurchargeMaster(_ref6) {
  var s = _ref6.s,
    orderDate = _ref6.orderDate;
  if (!s.SublineObjectDescription) {
    // console.log("SublineObjectDescription is null or empty")
    return null;
  }
  var sod = s.SublineObjectDescription;
  // console.log("SublineObjectDescription used to search for SurchargeMaster is " + sod)

  var surchargeMaster = pricer["SurchargeMaster"];
  var jsonContent = surchargeMaster;
  var sm = jsonContent.filter(function (x) {
    return x[pricerFieldsIdx["SurchargeMaster"]["SurchargeShortDesc"]].toLowerCase() == sod.toLowerCase() && x[pricerFieldsIdx["SurchargeMaster"]["SurchargeAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["SurchargeMaster"]["SurchargeAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["SurchargeMaster"]["SurchargeIsActive"]].toLowerCase() == "true";
  })[0];
  return sm;
};
var makeSurcharge = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7) {
    var s, price, sm, chg;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          s = _ref7.s, price = _ref7.price, sm = _ref7.sm;
          chg = {};
          chg.ChargeType = ChargeType.RegularSurcharge;
          chg.RefId = s.RefId;
          chg.ChargeId = sm[pricerFieldsIdx["SurchargeMaster"]["SurchargeID"]];
          chg.Description = sm[pricerFieldsIdx["SurchargeMaster"]["SurchargeDescription"]];
          chg.TheCharge = price;
          return _context3.abrupt("return", chg);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function makeSurcharge(_x3) {
    return _ref8.apply(this, arguments);
  };
}();
var getSurchargeQuantity = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref9) {
    var surchargeId, surchargeQuantity, jsonContent, sq;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          surchargeId = _ref9.surchargeId;
          surchargeQuantity = pricer["SurchargeQuantity"];
          jsonContent = surchargeQuantity;
          sq = jsonContent.filte(function (x) {
            return x.SurchargeId.toLowerCase() == surchargeId.toLowerCase();
          })[0];
          return _context4.abrupt("return", sq);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getSurchargeQuantity(_x4) {
    return _ref10.apply(this, arguments);
  };
}();
var getSurchargeFlat = function getSurchargeFlat(_ref11) {
  var surchargeId = _ref11.surchargeId;
  var surchargeFlat = pricer["SurchargeFlat"];
  var jsonContent = surchargeFlat;
  var sf = jsonContent.filte(function (x) {
    return x.SurchargeId.toLowerCase() == surchargeId.toLowerCase();
  })[0];
  return sf;
};

var price$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var d, orderDate, i, s, chg, _chg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          d = _ref.d;
          _context.prev = 1;
          orderDate = d.Parent.OrderDate;
          i = 0;
        case 4:
          if (!(i < d.Sublines.length)) {
            _context.next = 36;
            break;
          }
          s = d.Sublines[i]; //TODO: Checks for two part sublines
          //such as BleedMotif Part 1 and Part 2.
          _context.next = 8;
          return isThisMultiPartSubline({
            s: s
          });
        case 8:
          if (!_context.sent) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("continue", 33);
        case 10:
          _context.prev = 10;
          _context.next = 13;
          return get({
            s: s,
            orderDate: orderDate,
            d: d
          });
        case 13:
          chg = _context.sent;
          if (chg.TheCharge) {
            _context.next = 16;
            break;
          }
          return _context.abrupt("continue", 33);
        case 16:
          chg.RefId = s.RefId;
          //    console.log("Charge " + (chg.Description ?? "No Description") + " is " + chg.TheCharge.toString())
          _context.next = 19;
          return AddCharge(chg, d.allCharges);
        case 19:
          _context.next = 33;
          break;
        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](10);
          console.log("error in liner pricer", _context.t0);
          d.errors.push({
            message: "Error in liner subline price calcuation",
            errorDetails: _context.t0,
            error: true
          });
          _chg = {};
          _chg.ChargeType = ChargeType.NonAmendedSubline;
          _chg.RefId = s.RefId;
          _chg.Description = "LINER";
          _chg.TheCharge = 0;
          _chg.TypeOfSubline = SublineType.LINER;
          _context.next = 33;
          return AddCharge(_chg, d.allCharges);
        case 33:
          i++;
          _context.next = 4;
          break;
        case 36:
          _context.next = 42;
          break;
        case 38:
          _context.prev = 38;
          _context.t1 = _context["catch"](1);
          console.log("error in liner pricer", _context.t1);
          // throw { error: error }
          d.errors.push({
            message: "Error in liner price calcuation",
            errorDetails: _context.t1,
            error: true
          });
        case 42:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 38], [10, 21]]);
  }));
  return function price(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var get = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var s, orderDate, d, chg;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          s = _ref3.s, orderDate = _ref3.orderDate, d = _ref3.d;
          //  console.log("Enter NonAmendedSublinePricer.get");
          chg = {};
          chg.ChargeType = ChargeType.NonAmendedSubline;
          chg.RefId = s.RefId;
          _context2.prev = 4;
          _context2.t0 = s.SublineType;
          _context2.next = _context2.t0 === SublineType.LINER.toString() ? 8 : 12;
          break;
        case 8:
          _context2.next = 10;
          return priceLiner({
            s: s,
            orderDate: orderDate,
            d: d
          });
        case 10:
          chg = _context2.sent;
          return _context2.abrupt("break", 12);
        case 12:
          _context2.next = 17;
          break;
        case 14:
          _context2.prev = 14;
          _context2.t1 = _context2["catch"](4);
          throw _context2.t1;
        case 17:
          return _context2.abrupt("return", chg);
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 14]]);
  }));
  return function get(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var priceLiner = function priceLiner(_ref5) {
  var s = _ref5.s,
    orderDate = _ref5.orderDate,
    d = _ref5.d;
  // console.log("Enter NonAmendedSublinePricer.priceLiner");

  try {
    if (s.SublineObjectDescription == "NOLINER") {
      console.log("NOLINER. No Price.");
      return null;
    }
    var chg = {};
    chg.ChargeType = ChargeType.NonAmendedSubline;
    chg.RefId = s.RefId;
    chg.Description = "LINER";
    chg.TheCharge = 0;
    var qty = s.Quantity;
    var id = s.SublineObjectId;
    var itemXref = pricer["ItemXRef"];
    var jsonContentItemXref = itemXref;
    var ixr = jsonContentItemXref.filter(function (x) {
      return x[pricerFieldsIdx["ItemXRef"]["ItemID"]].toLowerCase() == id.toLowerCase() && x[pricerFieldsIdx["ItemXRef"]["ItemAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["ItemXRef"]["ItemAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["ItemXRef"]["ItemIsActive"]].toLowerCase() == 'true';
    })[0];
    if (!ixr) {
      d.errors.push({
        message: "ItemXRef entry not found for ItemID ".concat(id, " with ").concat(s.SublineObjectId, ", with order date ").concat(orderDate),
        errorDetails: null,
        error: true
      });
      return chg;
      //    ixr = window.pricerRecordsDefault.ItemXRef;
      //throw { error: "ItemXRef entry not found for ItemID " + id.toString() }
    }
    //    else {
    //  console.log("ItemXRef for ItemId " + id.toString() + " has JDEShortItemNumber of " + ixr[pricerFieldsIdx["ItemXRef"]["JDEShortItemNumber"]].toString())

    // let jden = ixr[pricerFieldsIdx["ItemXRef"]["JDEShortItemNumber"]];

    // let itemMaster = pricer["ItemMaster"];
    // let jsonContent = itemMaster;
    // let im = jsonContent.filter(x => x.JDEShortItemNumber == jden)[0];
    // let im = {}

    // if (!im) { throw { error: "ItemMaster entry not found for JDEShortItemNumber " + jden.toString() } }
    // else {
    //     console.log("ItemMaster for JDEShortItemNumber " + jden.toString() + " has im.PriceGroup of " + im.PriceGroup + " which is used to query for LinerPricingCategoryMaster.LinerPricingCategoryShortDesc")

    var ipg = "";
    if (!ixr[pricerFieldsIdx["ItemXRef"]["PriceGroup"]] || ixr[pricerFieldsIdx["ItemXRef"]["PriceGroup"]] == "NULL") {
      d.errors.push({
        message: "ItemXRef.PriceGroup is null or empty for ItemID ".concat(id, " with order date ").concat(orderDate),
        errorDetails: null,
        error: true
      });
      return chg;

      // if (!im.PriceGroup) {
      //     // d.errors.push({
      //     //     message: `ItemMaster.PriceGroup is null or empty for JDEShortItemNumber " + ${jden}`,
      //     //     errorDetails: error,
      //     //     error: true
      //     // })

      //     throw { error: `ItemXRef.PriceGroup is null or empty for ItemID ${id} with order date ${orderDate}` }
      // }
      // else {
      //     //     console.log("ItemMaster for JDEShortItemNumber " + jden.ToString() + " has im.PriceGroup of " + im.PriceGroup + " which is used to query for LinerPricingCategoryMaster.LinerPricingCategoryShortDesc")
      //     ipg = im.PriceGroup;
      // }
    } else {
      //  console.log("ItemMaster for JDEShortItemNumber " + jden.toString() + " has im.PriceGroup of " + im.PriceGroup + " which is used to query for LinerPricingCategoryMaster.LinerPricingCategoryShortDesc")
      ipg = ixr[pricerFieldsIdx["ItemXRef"]["PriceGroup"]];
    }

    // }
    ipg = ipg.trim();
    var linerPricingCategoryMaster = pricer["LinerPricingCategoryMaster"];
    var jsonContent = linerPricingCategoryMaster;
    var lpcm = jsonContent.filter(function (x) {
      return x[pricerFieldsIdx["LinerPricingCategoryMaster"]["LinerPricingCategoryShortDesc"]].toLowerCase() == ipg.toLowerCase() && x[pricerFieldsIdx["LinerPricingCategoryMaster"]["LinerPricingCategoryAvailabilityStart"]] <= orderDate && x[pricerFieldsIdx["LinerPricingCategoryMaster"]["LinerPricingCategoryAvailabilityEnd"]] >= orderDate && x[pricerFieldsIdx["LinerPricingCategoryMaster"]["LinerPricingCategoryIsActive"]].toLowerCase() == "true";
    })[0];
    if (lpcm == null) {
      d.errors.push({
        message: "LinerPricingCategoryMaster entry not found for LinerPricingCategoryShortDesc ".concat(ipg, " with itemXref itemId ").concat(s.SublineObjectId),
        errorDetails: null,
        error: true
      });
      return chg;
      //   throw { error: "LinerPricingCategoryMaster entry not found for LinerPricingCategoryShortDesc " + ipg };
      //  lpcm = window.pricerRecordsDefault.LinerPricingCategoryMaster;
    }
    var p = Number(lpcm[pricerFieldsIdx["LinerPricingCategoryMaster"]["LinerPricingCategoryPrice"]]);
    var qv = 25;
    var _price = Number(qty / qv * p).toFixed(2);
    chg.TheCharge = _price;
    chg.TypeOfSubline = SublineType.LINER;
    return chg;
    // }
  } catch (error) {
    throw error;
  }
};

var pricingEngine = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var h, runDate, po, pricedOrderForReturn;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          h = _ref.pricingOrder;
          // console.log("Enter CranePricingEngine.Calculate");
          console.log("pricingOrder ", h);
          // let runDate = new Date();
          // runDate = await formatDate(runDate);
          runDate = h.OrderDate; // console.log("run date", runDate);
          //Validate incoming data.
          //if errors, return a carrier PricedOrder
          //with data about errors.
          // var incVal = new IncomingOrderValidator();
          // var priced1 = incVal.Validate(h);
          // var haserr = DoesOrderHaveValidationErrors(priced1);
          // if (haserr)
          // { return priced1; }
          // copy into pricing order, set relation,institate collection
          po = null;
          _context.prev = 4;
          _context.next = 7;
          return copyIntoPricingOrder({
            runDate: runDate,
            h: h
          });
        case 7:
          po = _context.sent;
          _context.next = 14;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](4);
          console.log("error in copyIntoPricingOrder", _context.t0);
          throw {
            error: "error in copyIntoPricingOrder"
          };
        case 14:
          _context.next = 16;
          return ipcCraneCalculate({
            h: po
          });
        case 16:
          _context.next = 19;
          return loadReturnObject({
            h: po
          });
        case 19:
          pricedOrderForReturn = _context.sent;
          // pricedOrderForReturn.RetailMultiplier = getRetailMultiplier(dcn);
          pricedOrderForReturn.RetailMultiplier = 200;
          pricedOrderForReturn.CustomerNumber = h.CustomerNumber;
          pricedOrderForReturn.errors = Object.assign([], pricedOrderForReturn.Details[0].errors);
          delete pricedOrderForReturn.Details[0].errors;
          _context.next = 26;
          return priceTotler({
            entity: pricedOrderForReturn
          });
        case 26:
          return _context.abrupt("return", pricedOrderForReturn);
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 10]]);
  }));
  return function pricingEngine(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var ipcCraneCalculate = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var h, i, d, isKitResponse;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          h = _ref3.h;
          if (!(h == null)) {
            _context2.next = 3;
            break;
          }
          throw {
            error: "Order is null."
          };
        case 3:
          if (!(h.Details == null)) {
            _context2.next = 5;
            break;
          }
          throw {
            error: "Order Detail collection is null."
          };
        case 5:
          if (!(h.Details.length <= 0)) {
            _context2.next = 7;
            break;
          }
          throw {
            error: "Order Detail collection is empty."
          };
        case 7:
          i = 0;
        case 8:
          if (!(i < h.Details.length)) {
            _context2.next = 19;
            break;
          }
          // console.log("pricingDetail", pricingDetail)
          d = Object.assign(pricingDetail, h.Details[i]);
          _context2.next = 12;
          return isKit({
            d: d
          });
        case 12:
          isKitResponse = _context2.sent;
          if (isKitResponse) {
            _context2.next = 16;
            break;
          }
          _context2.next = 16;
          return price({
            d: d
          });
        case 16:
          i++;
          _context2.next = 8;
          break;
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function ipcCraneCalculate(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var price = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var d;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          d = _ref5.d;
          _context3.next = 3;
          return runPricers({
            d: d
          });
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function price(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var runPricers = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var d;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          d = _ref7.d;
          _context4.next = 3;
          return price$8({
            d: d
          });
        case 3:
          _context4.next = 5;
          return price$7({
            d: d
          });
        case 5:
          _context4.next = 7;
          return price$6({
            d: d
          });
        case 7:
          _context4.next = 9;
          return price$5({
            d: d
          });
        case 9:
          _context4.next = 11;
          return price$4({
            d: d
          });
        case 11:
          _context4.next = 13;
          return price$3({
            d: d
          });
        case 13:
          _context4.next = 15;
          return price$2({
            d: d
          });
        case 15:
          _context4.next = 17;
          return price$1({
            d: d
          });
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function runPricers(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _recursiveCombine = function recursiveCombine(combinations, productPartStructure, oneCombinationStructure, elCount) {
  if (elCount >= productPartStructure.elements.length) {
    console.log('... ', oneCombinationStructure.elements.length);
    combinations.push(JSON.parse(JSON.stringify(oneCombinationStructure)));
    return; // end recursion
  }
  var currentElement = productPartStructure.elements[elCount];
  if (currentElement.type == 'liner') {
    // for now we iterate all liners, assuming they are priced differently? otherwise just take the first liner ...
    for (var linerK = 0; linerK < currentElement.value.length; linerK++) {
      var combinedElement = JSON.parse(JSON.stringify(currentElement));
      combinedElement.value = combinedElement.value[linerK];
      oneCombinationStructure.elements.push(combinedElement);
      _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
      oneCombinationStructure.elements.pop();
    }
  } else if (currentElement.type == 'text') {
    for (var printK = 0; printK < currentElement.prints.length; printK++) {
      // first color
      var _combinedElement = JSON.parse(JSON.stringify(currentElement));
      _combinedElement.print = _combinedElement.prints[printK];
      _combinedElement.color = _combinedElement.colors[0];
      delete _combinedElement.prints;
      delete _combinedElement.colors;
      oneCombinationStructure.elements.push(_combinedElement);
      _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
      oneCombinationStructure.elements.pop();
      // second color (no need to take more)
      if (currentElement.colors.length > 1) {
        var combinedElement2 = JSON.parse(JSON.stringify(currentElement));
        combinedElement2.print = combinedElement2.prints[printK];
        combinedElement2.color = combinedElement2.colors[1];
        delete combinedElement2.colors;
        delete combinedElement2.prints;
        // replace previous element
        oneCombinationStructure.elements.push(combinedElement2);
        _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
        oneCombinationStructure.elements.pop();
      }
    }
  } else if (currentElement.type == 'motif') {
    for (var printK = 0; printK < currentElement.prints.length; printK++) {
      // first color
      var _combinedElement2 = JSON.parse(JSON.stringify(currentElement));
      _combinedElement2.value = _combinedElement2.value[0]; // no need to iterate for each motif
      _combinedElement2.print = _combinedElement2.prints[printK];
      _combinedElement2.color = _combinedElement2.colors[0];
      delete _combinedElement2.prints;
      delete _combinedElement2.colors;
      oneCombinationStructure.elements.push(_combinedElement2);
      _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
      oneCombinationStructure.elements.pop();
      // second color (no need to take more)
      if (currentElement.colors.length > 1) {
        var _combinedElement3 = JSON.parse(JSON.stringify(currentElement));
        _combinedElement3.value = _combinedElement3.value[0]; // no need to iterate for each motif
        _combinedElement3.print = _combinedElement3.prints[printK];
        _combinedElement3.color = _combinedElement3.colors[1];
        delete _combinedElement3.prints;
        delete _combinedElement3.colors;
        // replace previous element
        oneCombinationStructure.elements.push(_combinedElement3);
        _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
        oneCombinationStructure.elements.pop();
      }
    }
  } else if (currentElement.type == 'monogram') {
    for (var printK = 0; printK < currentElement.prints.length; printK++) {
      // first color
      var _combinedElement4 = JSON.parse(JSON.stringify(currentElement));
      _combinedElement4.print = _combinedElement4.prints[printK];
      _combinedElement4.color = _combinedElement4.colors[0];
      delete _combinedElement4.prints;
      delete _combinedElement4.colors;
      oneCombinationStructure.elements.push(_combinedElement4);
      _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
      oneCombinationStructure.elements.pop();
      // second color (no need to take more)
      if (currentElement.colors.length > 1) {
        var _combinedElement5 = JSON.parse(JSON.stringify(currentElement));
        _combinedElement5.print = _combinedElement5.prints[printK];
        _combinedElement5.color = _combinedElement5.colors[1];
        delete _combinedElement5.prints;
        delete _combinedElement5.colors;
        // replace previous element
        oneCombinationStructure.elements.push(_combinedElement5);
        _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
        oneCombinationStructure.elements.pop();
      }
    }
  } else if (currentElement.type == 'clipart') {
    var _combinedElement6 = JSON.parse(JSON.stringify(currentElement));
    _combinedElement6.value = _combinedElement6.value || "clipart";
    oneCombinationStructure.elements.push(_combinedElement6);
    _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
    oneCombinationStructure.elements.pop();
  } else if (currentElement.type == 'image') {
    var _combinedElement7$val;
    var _combinedElement7 = JSON.parse(JSON.stringify(currentElement));
    _combinedElement7.value = ((_combinedElement7$val = _combinedElement7.value) === null || _combinedElement7$val === void 0 ? void 0 : _combinedElement7$val[0]) || 'image';
    oneCombinationStructure.elements.push(_combinedElement7);
    _recursiveCombine(combinations, productPartStructure, JSON.parse(JSON.stringify(oneCombinationStructure)), elCount + 1);
    oneCombinationStructure.elements.pop();
  }
};
var combine = function combine(structure) {
  var combined_structures = [];
  var _iterator = _createForOfIteratorHelper(structure.papers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var paper = _step.value;
      // const newStructure = {
      //   paper: paper, elements: []
      // }
      var newStructure = Object.assign(_objectSpread$2({}, structure), {
        paper: paper,
        elements: []
      });
      delete newStructure.papers;
      _recursiveCombine(combined_structures, structure, newStructure, 0);
    }
    // console.log('combinations count: ', combined_structures.length)
    // console.log('conbinations[0] elements count:', combined_structures[0].elements.length)
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return combined_structures;
  // for (var i = 0; i < 3; i ++) {
  //     console.log('combination:',i )
  //     console.log(JSON.stringify(combined_structures[i]))
  // }
};

// let baseUrl = null;
// let craneOrderApiUrl = null;

var processors$1 = {
  Thermography: 1,
  Engraving: 2,
  Letterpress: 5,
  Digital: 21,
  Embossing: 6,
  "Flat Print": 7,
  Flat: 7,
  Foil: 15
};
var printShortName$1 = {
  Thermography: "T",
  Engraving: "E",
  Letterpress: "L",
  Digital: "G",
  Embossing: "B",
  "Flat Print": "F",
  Flat: "F",
  Foil: "R"
};
var SublineTypeIds$1 = {
  text: 14,
  motif: 14,
  monogram: 14,
  liner: 8,
  image: 14,
  clipart: 14
};
var getSelectedPrintOption$1 = function getSelectedPrintOption(element) {
  var print = {};
  if (element && element.attributes) {
    var dataPrint = element.attributes.filter(function (attribute) {
      return attribute.key === "data-selected-print-type";
    })[0];
    if (dataPrint && dataPrint.value) {
      var option = dataPrint.value.replace(/'/g, '"');
      // for (let p = 0; p < options.printTypeOptions.length; p++) {
      print = {
        name: option,
        processId: processors$1[option],
        shortName: printShortName$1[option]
      };
      // }
    }
  }
  return print;
};
// this function create a part structure only from element SELECTED property
var _getPartStructure = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var element, elementProperties, partAssets, surfaceId, _dataVisible, dataFontStyle, fontObject, dataSelectedFontFamily, dataSelectedFontSize, dataSelectedLetterSpacing, dataSelectedLineHeight, dataIsStyleLinked, dataColorStyle, dataProcessStyle, dataElementName, dataVisible, dataSelectedColor, dataElementUniqueId, dataSelectedPaper, selectedPaperObj, dataFinish, dataFinishObj, liner, dataDefaultText, _dataOptional, _dataOptionalAdded, dataOptional, dataOptionalAdded, defaultText, dataSelectedMotif, dataMotifs, motifOptions, motif, option, _option, dataSelectedMonogram, dataMonograms, monogramOptions, monogram, _option2, _option3, dataImage, options, _options$selectedImag, _options$selectedImag2, _options$selectedImag3, image, dataType, dataClipartImage, url, n;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          element = _ref.element, elementProperties = _ref.elementProperties, partAssets = _ref.partAssets, surfaceId = _ref.surfaceId;
          _context.prev = 1;
          if (element.attributes) {
            dataFontStyle = null;
            fontObject = null;
            dataFontStyle = element.attributes.filter(function (attribute) {
              return attribute.key === "data-font-style";
            })[0];
            if (dataFontStyle && dataFontStyle.value) {
              dataFontStyle = decodeURIComponent(dataFontStyle.value);
              dataSelectedFontFamily = element.attributes.filter(function (attribute) {
                return attribute.key === "data-selected-font-family";
              })[0];
              dataSelectedFontSize = element.attributes.filter(function (attribute) {
                return attribute.key === "data-selected-font-size";
              })[0];
              dataSelectedLetterSpacing = element.attributes.filter(function (attribute) {
                return attribute.key === "data-selected-letter-spacing";
              })[0];
              dataSelectedLineHeight = element.attributes.filter(function (attribute) {
                return attribute.key === "data-selected-line-height";
              })[0];
              fontObject = {
                name: dataSelectedFontFamily.value,
                defaultValue: dataSelectedFontSize.value,
                letterSpacing: dataSelectedLetterSpacing.value,
                lineHeight: dataSelectedLineHeight.value
              };
            }
            dataIsStyleLinked = null;
            dataIsStyleLinked = element.attributes.filter(function (attribute) {
              return attribute.key === "data-is-style-linked";
            })[0];
            if (dataIsStyleLinked && dataIsStyleLinked.value) {
              dataIsStyleLinked = decodeURIComponent(dataIsStyleLinked.value);
            }
            dataColorStyle = null;
            dataColorStyle = element.attributes.filter(function (attribute) {
              return attribute.key === "data-color-style";
            })[0];
            if (dataColorStyle && dataColorStyle.value) {
              dataColorStyle = decodeURIComponent(dataColorStyle.value);
            }
            dataProcessStyle = null;
            dataProcessStyle = element.attributes.filter(function (attribute) {
              return attribute.key === "data-process-style";
            })[0];
            if (dataProcessStyle && dataProcessStyle.value) {
              dataProcessStyle = decodeURIComponent(dataProcessStyle.value);
            }
            dataElementName = null;
            dataElementName = element.attributes.filter(function (attribute) {
              return attribute.key === "data-element-name";
            })[0];
            if (dataElementName && dataElementName.value) {
              dataElementName = decodeURIComponent(dataElementName.value);
              dataElementName = getName$1({
                elements: partAssets.elements,
                name: dataElementName
              });
            }
            //  else{
            //  console.log("data element name not present")
            //  }
            dataVisible = null;
            dataVisible = element.attributes.filter(function (attribute) {
              return attribute.key === "data-visible";
            })[0];
            dataVisible = dataVisible && dataVisible.value !== "undefined" ? JSON.parse(dataVisible.value.replace(/'/g, '"')) : (_dataVisible = dataVisible) === null || _dataVisible === void 0 || (_dataVisible = _dataVisible.value) === null || _dataVisible === void 0 ? void 0 : _dataVisible.replace(/'/g, '"');
            dataSelectedColor = element.attributes.filter(function (attribute) {
              return attribute.key === "data-color";
            });
            dataSelectedColor = dataSelectedColor && dataSelectedColor[0] ? dataSelectedColor[0] : {};
            dataElementUniqueId = element.attributes.filter(function (attribute) {
              return attribute.key === "data-element-unique-id";
            });
            dataElementUniqueId = dataElementUniqueId && dataElementUniqueId[0] ? dataElementUniqueId[0].value : null;
            dataSelectedPaper = element.attributes.filter(function (attribute) {
              return attribute.key === "data-selected-paper-type";
            })[0];
            if (dataSelectedPaper && dataSelectedPaper.value) {
              selectedPaperObj = JSON.parse(dataSelectedPaper.value.replace(/'/g, '"')); // if (selectedPaperObj && partAssets.papers) {
              //   partAssets.papers.unshift(selectedPaperObj.name);
              // }
              if (selectedPaperObj && partAssets.papers) {
                partAssets.paper = selectedPaperObj.name;
                partAssets.paperWidth = selectedPaperObj.width;
                partAssets.paperHeight = selectedPaperObj.height;
              }
            }
            dataFinish = element.attributes.filter(function (attribute) {
              return attribute.key === "data-finish";
            })[0];
            if (dataFinish && dataFinish.value) {
              dataFinishObj = JSON.parse(dataFinish.value.replace(/'/g, '"'));
              if (dataFinishObj && dataFinishObj.selectedLiner) {
                liner = {
                  omsKey: dataFinishObj.selectedLiner.linerOmsKey,
                  name: dataFinishObj.selectedLiner.name,
                  linerId: dataFinishObj.selectedLiner.linerId,
                  id: dataFinishObj.selectedLiner.id
                };
                dataElementName = dataElementName ? dataElementName : getName$1({
                  elements: partAssets.elements,
                  name: "liner"
                });
                partAssets.elements.push({
                  type: "liner",
                  value: liner,
                  sublineTypeId: SublineTypeIds$1["liner"],
                  surfaceId: surfaceId,
                  name: dataElementName,
                  styleLinked: dataIsStyleLinked,
                  processStyle: dataProcessStyle,
                  colorStyle: dataColorStyle,
                  fontStyle: dataFontStyle
                });
              }
            }

            // end of paper assets

            // for text assets
            dataDefaultText = element.attributes.filter(function (attribute) {
              return attribute.key === "data-text";
            })[0];
            if (dataDefaultText && dataDefaultText.value) {
              dataOptional = element.attributes.filter(function (attribute) {
                return attribute.key === "data-optional";
              })[0];
              dataOptional = dataOptional && dataOptional.value !== "undefined" ? JSON.parse(dataOptional.value.replace(/'/g, '"')) : (_dataOptional = dataOptional) === null || _dataOptional === void 0 ? void 0 : _dataOptional.value.replace(/'/g, '"');
              dataOptionalAdded = element.attributes.filter(function (attribute) {
                return attribute.key === "data-optional-added";
              })[0];
              dataOptionalAdded = (_dataOptionalAdded = dataOptionalAdded) === null || _dataOptionalAdded === void 0 ? void 0 : _dataOptionalAdded.value.replace(/'/g, '"');

              // let needToSkip =
              //   ["true", true].includes(dataOptional) &&
              //   !["true", true].includes(dataOptionalAdded);
              defaultText = JSON.parse(dataDefaultText.value.replace(/'/g, '"'));
              dataElementName = dataElementName ? dataElementName : getName$1({
                elements: partAssets.elements,
                name: "text"
              });
              if (defaultText.length) {
                // && defaultText[0].length
                partAssets.elements.push({
                  type: "text",
                  value: defaultText.map(function (text) {
                    return unescape(text);
                  }).join("\n"),
                  color: JSON.parse(dataSelectedColor.value.replace(/'/g, '"')),
                  print: getSelectedPrintOption$1(element),
                  font: fontObject,
                  sublineTypeId: SublineTypeIds$1["text"],
                  surfaceId: surfaceId,
                  removed: defaultText.map(function (text) {
                    return unescape(text);
                  }).join("\n").length === 0,
                  elementId: dataElementUniqueId,
                  name: dataElementName,
                  isOptional: dataOptional ? dataOptional : null,
                  isOptionalAdded: dataOptionalAdded ? dataOptionalAdded : null,
                  styleLinked: dataIsStyleLinked,
                  processStyle: dataProcessStyle,
                  colorStyle: dataColorStyle,
                  fontStyle: dataFontStyle
                });
              }
            }

            // for motif assets
            dataSelectedMotif = element.attributes.filter(function (attribute) {
              return attribute.key === "data-selected-motif";
            })[0];
            dataMotifs = element.attributes.filter(function (attribute) {
              return attribute.key === "data-motif";
            })[0];
            if (dataMotifs && dataMotifs.value) {
              motifOptions = JSON.parse(dataMotifs.value.replace(/'/g, '"'));
              motif = {};
              if (dataSelectedMotif && dataSelectedMotif.value) {
                option = JSON.parse(dataSelectedMotif.value.replace(/'/g, '"'));
                motif = {
                  name: option.name,
                  id: option.id,
                  url: option.url
                };
              } else {
                _option = motifOptions.motifOptions[0];
                motif = {
                  name: _option.name,
                  id: _option.id,
                  url: _option.url
                };
              }
              dataElementName = dataElementName ? dataElementName : getName$1({
                elements: partAssets.elements,
                name: "motif"
              });
              partAssets.elements.push({
                type: "motif",
                value: motif,
                color: JSON.parse(dataSelectedColor.value.replace(/'/g, '"')),
                print: getSelectedPrintOption$1(element),
                sublineTypeId: SublineTypeIds$1["motif"],
                surfaceId: surfaceId,
                removed: ["false", false].includes(dataVisible),
                elementId: dataElementUniqueId,
                name: dataElementName,
                styleLinked: dataIsStyleLinked,
                processStyle: dataProcessStyle,
                colorStyle: dataColorStyle,
                fontStyle: dataFontStyle
              });
            }

            // for monogram assets
            dataSelectedMonogram = element.attributes.filter(function (attribute) {
              return attribute.key === "data-selected-monogram";
            })[0];
            dataMonograms = element.attributes.filter(function (attribute) {
              return attribute.key === "data-monogram";
            })[0];
            if (dataMonograms && dataMonograms.value) {
              monogramOptions = JSON.parse(dataMonograms.value.replace(/'/g, '"'));
              monogram = {};
              if (dataSelectedMonogram && dataSelectedMonogram.value) {
                _option2 = JSON.parse(dataSelectedMonogram.value.replace(/'/g, '"'));
                monogram = {
                  name: _option2.name,
                  id: _option2.id,
                  url: _option2.url
                };
              } else {
                _option3 = monogramOptions.monogramOptions[0];
                monogram = {
                  name: _option3.name,
                  id: _option3.id,
                  url: _option3.url
                };
              }
              dataElementName = dataElementName ? dataElementName : getName$1({
                elements: partAssets.elements,
                name: "monogram"
              });
              partAssets.elements.push({
                type: "monogram",
                value: monogram,
                color: JSON.parse(dataSelectedColor.value.replace(/'/g, '"')),
                print: getSelectedPrintOption$1(element),
                font: fontObject,
                sublineTypeId: SublineTypeIds$1["monogram"],
                surfaceId: surfaceId,
                removed: ["false", false].includes(dataVisible),
                elementId: dataElementUniqueId,
                name: dataElementName,
                styleLinked: dataIsStyleLinked,
                processStyle: dataProcessStyle,
                colorStyle: dataColorStyle,
                fontStyle: dataFontStyle
              });
            }

            // for image assets
            dataImage = element.attributes.filter(function (attribute) {
              return attribute.key === "data-image";
            })[0];
            if (dataImage && dataImage.value) {
              options = JSON.parse(dataImage.value.replace(/'/g, '"'));
              if (options && options.isImage) {
                image = {
                  name: (_options$selectedImag = options.selectedImage) === null || _options$selectedImag === void 0 ? void 0 : _options$selectedImag.name,
                  id: (_options$selectedImag2 = options.selectedImage) === null || _options$selectedImag2 === void 0 ? void 0 : _options$selectedImag2.id,
                  url: (_options$selectedImag3 = options.selectedImage) === null || _options$selectedImag3 === void 0 ? void 0 : _options$selectedImag3.url
                };
                dataElementName = dataElementName ? dataElementName : getName$1({
                  elements: partAssets.elements,
                  name: "image"
                });
                partAssets.elements.push({
                  type: "image",
                  value: image,
                  print: getSelectedPrintOption$1(element),
                  sublineTypeId: SublineTypeIds$1["image"],
                  surfaceId: surfaceId,
                  removed: ["false", false].includes(dataVisible),
                  elementId: dataElementUniqueId,
                  name: dataElementName,
                  styleLinked: dataIsStyleLinked,
                  processStyle: dataProcessStyle,
                  colorStyle: dataColorStyle,
                  fontStyle: dataFontStyle
                });
              }
            }

            // for image assets
            dataType = element.attributes.filter(function (attribute) {
              return attribute.key === "data-type";
            })[0];
            if (dataType && dataType.value === "clipart") {
              dataClipartImage = element.attributes.filter(function (attribute) {
                return attribute.key === "data-clipart-image-url";
              })[0];
              url = dataClipartImage ? dataClipartImage.value : null;
              dataElementName = dataElementName ? dataElementName : getName$1({
                elements: partAssets.elements,
                name: "clipart"
              });
              partAssets.elements.push({
                type: "clipart",
                value: url ? decodeURIComponent(url) : "clipart",
                print: getSelectedPrintOption$1(element),
                sublineTypeId: SublineTypeIds$1["clipart"],
                surfaceId: surfaceId,
                elementId: dataElementUniqueId,
                name: dataElementName,
                styleLinked: dataIsStyleLinked,
                processStyle: dataProcessStyle,
                colorStyle: dataColorStyle,
                fontStyle: dataFontStyle
              });
            }
          }
          _context.next = 9;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](1);
          console.log("error in attributes", _context.t0);
          throw _context.t0;
        case 9:
          if (!element.children) {
            _context.next = 17;
            break;
          }
          n = 0;
        case 11:
          if (!(n < element.children.length)) {
            _context.next = 17;
            break;
          }
          _context.next = 14;
          return _getPartStructure({
            element: element.children[n],
            elementProperties: elementProperties,
            partAssets: partAssets,
            surfaceId: surfaceId
          });
        case 14:
          n++;
          _context.next = 11;
          break;
        case 17:
          return _context.abrupt("return", element);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 5]]);
  }));
  return function getPartStructure(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getCurrentSvgPartStructure = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(svgCode, partAssets, sessionItem) {
    var elementProperties, parsedSvg, svgElement, doctType, j, children;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          elementProperties = {};
          parsedSvg = parse(svgCode);
          svgElement = parsedSvg.filter(function (element) {
            return element.tagName === "svg";
          })[0];
          doctType = parsedSvg.filter(function (element) {
            return element.tagName === "!doctype";
          })[0];
          doctType.tagName = "!DOCTYPE";
          if (!svgElement.children) {
            _context2.next = 16;
            break;
          }
          console.log("children.length", svgElement.children.length);
          j = 0;
        case 9:
          if (!(j < svgElement.children.length)) {
            _context2.next = 16;
            break;
          }
          children = svgElement.children[j];
          _context2.next = 13;
          return _getPartStructure({
            element: children,
            elementProperties: elementProperties,
            partAssets: partAssets,
            surfaceId: sessionItem.surface
          });
        case 13:
          j++;
          _context2.next = 9;
          break;
        case 16:
          return _context2.abrupt("return", {
            partAssets: JSON.parse(JSON.stringify(partAssets))
          });
        case 19:
          _context2.prev = 19;
          _context2.t0 = _context2["catch"](0);
          throw _context2.t0;
        case 22:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 19]]);
  }));
  return function getCurrentSvgPartStructure(_x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
var getName$1 = function getName(_ref4) {
  var elements = _ref4.elements,
    name = _ref4.name;
  try {
    if (elements && elements.length) {
      var count = elements.filter(function (ele) {
        return ele.name.split('-')[0] === name;
      });
      if (count.length) {
        console.log("name present", count);
        return name + "-" + count.length;
      } else return name;
    }
  } catch (error) {
    console.log("error in get name", error);
  }
  return name;
};

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// let imageLibApiUrl = null;
// let craneOrderApiUrl = null;
// let currentType = null;
var imageLibApiUrl = import.meta.env ? import.meta.env.VITE_IMAGELIB_API_URL : null;
var craneOrderApiUrl = import.meta.env ? import.meta.env.VITE_CRANE_ORDER_API_URL : null;

// if (typeof process !== 'undefined' && process.env) {
//     // Node.js environment
//     currentType = 'node'
//     if (process.env.NODE_ENV == "staging" || !process.env.NODE_ENV) {
//         imageLibApiUrl = "https://imagelib-api-stg.crane.com";
//         craneOrderApiUrl = "https://ordertest.crane.com";
//     } else {
//         imageLibApiUrl = process.env.IMAGELIB_API_URL;
//         craneOrderApiUrl = process.env.CRANE_ORDER_URL;
//     }
// }
// else if (typeof import.meta !== 'undefined' && import.meta.env) {
//     currentType = 'browser'
//     // Vite (Vue 3) environment
//     imageLibApiUrl =  import.meta.env.VITE_IMAGELIB_API_URL
//     craneOrderApiUrl =  import.meta.env.VITE_CRANE_ORDER_API_URL
// }

var handleResponse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", response.text().then(function (text) {
            var data = text && JSON.parse(text);
            if (!response.ok) {
              var error = data && data.message || response.statusText;
              return Promise.reject(error);
            } else {
              return data;
            }
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handleResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();
var doFetchPartPrice = function doFetchPartPrice(_ref2) {
  var order = _ref2.order;
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*"
    },
    body: JSON.stringify({
      order: order
    })
  };
  return fetch("".concat(craneOrderApiUrl, "/pricer/price"), requestOptions).then(handleResponse);
};
var doFetchLinerList = function doFetchLinerList(_ref3) {
  var tags = _ref3.tags;
  var requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return fetch("".concat(imageLibApiUrl, "/liner?tags=ov.{").concat(tags, "}"), requestOptions).then(handleResponse);
};
var doPostIncidentOne = function doPostIncidentOne(_ref4) {
  var one = _ref4.one;
  var requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/vnd.pgrst.object+json',
      'Prefer': 'return=representation'
    },
    body: JSON.stringify(_objectSpread$1({}, one))
  };
  return fetch("".concat(imageLibApiUrl, "/incident"), requestOptions);
};
var doFetchColorsByTags = function doFetchColorsByTags(tags) {
  var requestOptions = {
    method: 'GET',
    headers: {
      'Content-type': 'application/json'
    }
  };
  var res = fetch("".concat(imageLibApiUrl, "/color?tags=ov.{").concat(tags, "}&order=sort.asc&select=id,name,cid:color_id,process_hex,short_name"), requestOptions).then(handleResponse);
  return res;
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function saveIncident(_x) {
  return _saveIncident.apply(this, arguments);
}
function _saveIncident() {
  _saveIncident = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref) {
    var errorObject, title, description, tags, details, currentdate, incidentObj;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          errorObject = _ref.errorObject, title = _ref.title, description = _ref.description, tags = _ref.tags, details = _ref.details;
          _context5.prev = 1;
          currentdate = new Date().toISOString();
          incidentObj = {
            app_id: 'crane',
            organization_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            module: 'cloud_pricer',
            level: "major",
            title: title,
            description: description,
            tags: tags,
            recorded_at: currentdate,
            metadata: {
              currentSessionId: details.currentSessionId,
              orderObject: details.orderObject,
              //  errorStack: JSON.stringify(errorObject),
              error: JSON.stringify(errorObject)
              // platform: userAgent?.platform,
              // appVersion: userAgent?.appVersion,
              // appCodeName: userAgent?.appCodeName,
            }
          };
          _context5.next = 6;
          return doPostIncidentOne({
            one: incidentObj
          });
        case 6:
          _context5.next = 12;
          break;
        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](1);
          console.log("Error while saving error incident ", _context5.t0);
          throw _context5.t0;
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 8]]);
  }));
  return _saveIncident.apply(this, arguments);
}
var doCallPricerEngine = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orderObject, currentSessionId, returnError) {
    var newApiResp, newPrice, e, errorMsg, errorDetails;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          orderObject = JSON.stringify(orderObject);
          // console.log("Order pricer is called ", JSON.parse(orderObject));
          _context.next = 4;
          return pricingEngine({
            pricingOrder: JSON.parse(orderObject)
          });
        case 4:
          newApiResp = _context.sent;
          newPrice = newApiResp.Total * (newApiResp.RetailMultiplier / 100);
          newPrice = Math.round(newPrice * 100) / 100;
          // console.log("Price for current combination", newPrice);
          // console.log("Current session id for price-engine ", currentSessionId);
          if (!(newApiResp && newApiResp.errors && newApiResp.errors.length)) {
            _context.next = 16;
            break;
          }
          if (!(returnError != "true")) {
            _context.next = 16;
            break;
          }
          e = 0;
        case 10:
          if (!(e < newApiResp.errors.length)) {
            _context.next = 16;
            break;
          }
          _context.next = 13;
          return saveIncident({
            errorObject: newApiResp.errors[e],
            title: "Cloud price error",
            description: newApiResp.errors[e].message,
            tags: ["cloud_price_error"],
            details: {
              orderObject: orderObject,
              currentSessionId: currentSessionId
            }
          });
        case 13:
          e++;
          _context.next = 10;
          break;
        case 16:
          if (!(newApiResp && newApiResp.Total === 0)) {
            _context.next = 23;
            break;
          }
          _context.next = 19;
          return saveIncident({
            errorObject: newApiResp.errors,
            title: "Cloud price error",
            description: "PricerEngine response has total 0",
            tags: ["cloud_price_error"],
            details: {
              orderObject: orderObject,
              currentSessionId: currentSessionId
            }
          });
        case 19:
          console.log("PricerEngine response when total is 0 ", newApiResp);
          return _context.abrupt("return", {
            error: true,
            errorMessage: "Error : Pricer engine failed, total = 0",
            orderObject: orderObject,
            errors: newApiResp.errors
          });
        case 23:
          return _context.abrupt("return", {
            error: false,
            newPrice: newPrice,
            errors: newApiResp.errors
          });
        case 24:
          _context.next = 32;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          errorMsg = _context.t0.error && _context.t0.error.error ? _context.t0.error.error : _context.t0.error ? _context.t0.error : _context.t0.message ? _context.t0.message : _context.t0;
          errorDetails = _context.t0.errorDetails;
          return _context.abrupt("return", {
            error: true,
            errorMessage: errorMsg,
            errorDetails: errorDetails,
            orderObject: orderObject
          });
        case 32:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 26]]);
  }));
  return function doCallPricerEngine(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var doCallPricerApi = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(orderObject) {
    var oldApiResp, oldPrice, errorMsg;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          orderObject = JSON.stringify(orderObject);
          _context2.next = 4;
          return doFetchPartPrice({
            order: JSON.parse(orderObject)
          });
        case 4:
          oldApiResp = _context2.sent;
          oldPrice = oldApiResp.PriceResult.Total * (oldApiResp.PriceResult.RetailMultiplier / 100);
          console.log("old price - ".concat(oldPrice, " "));
          if (!(oldPrice === 0)) {
            _context2.next = 12;
            break;
          }
          console.error("Error : Pricer api failed for current order object", JSON.stringify({
            pricingOrder: orderObject
          }));
          return _context2.abrupt("return", {
            error: true,
            errorMessage: "Error : Pricer api failed, total = 0",
            orderObject: orderObject
          });
        case 12:
          return _context2.abrupt("return", {
            error: false,
            oldPrice: oldPrice
          });
        case 13:
          _context2.next = 20;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](0);
          console.log(_context2.t0);
          errorMsg = _context2.t0.error && _context2.t0.error.error ? _context2.t0.error.error : _context2.t0.error ? _context2.t0.error : _context2.t0.message ? _context2.t0.message : _context2.t0;
          return _context2.abrupt("return", {
            error: true,
            errorMessage: errorMsg,
            orderObject: orderObject
          });
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 15]]);
  }));
  return function doCallPricerApi(_x5) {
    return _ref3.apply(this, arguments);
  };
}();
var getSublinesFromStructureElement = function getSublinesFromStructureElement(_ref4) {
  var newStructure = _ref4.newStructure,
    orderObject = _ref4.orderObject,
    quantity = _ref4.quantity;
  try {
    if (newStructure && newStructure.elements) {
      for (var e = 0; e < newStructure.elements.length; e++) {
        var _currentEle$color, _currentEle$print;
        var currentEle = newStructure.elements[e];
        var isOptional = currentEle.isOptional ? "" + currentEle.isOptional : null;
        var isOptionalAdded = currentEle.isOptionalAdded ? "" + currentEle.isOptionalAdded : null;
        if (isOptional && isOptional == "true") {
          if (isOptionalAdded && isOptionalAdded == "true") {} else {
            continue;
          }
        }
        if (currentEle.removed && currentEle.removed == true) continue;
        // current color
        var currentColor = (_currentEle$color = currentEle["color"]) !== null && _currentEle$color !== void 0 && _currentEle$color.cid ? currentEle["color"] : {};
        // current print
        var currentPrint = (_currentEle$print = currentEle["print"]) !== null && _currentEle$print !== void 0 && _currentEle$print.name ? currentEle["print"] : {};
        var newOrderSubObject = {
          RefId: Date.now().toString(),
          ProcessId: currentPrint.processId,
          // print method
          ColorId: currentColor.cid,
          // text color
          Quantity: quantity,
          SurfaceId: currentEle.surfaceId,
          SublineObjectId: newStructure.sublineObjectId,
          PartId: newStructure.partId,
          BevelId: newStructure.bevelId
        };
        if (currentEle.type === "text") {
          orderObject.Details[0].Sublines.push(_objectSpread(_objectSpread({}, newOrderSubObject), {}, {
            SublineTypeId: currentEle.sublineTypeId,
            SublineObjectDescription: currentEle.value,
            SublineObjectText: currentEle.value
          }));
        }
        // current liner
        if (currentEle.type === "liner" && currentEle.value) {
          var _currentEle$value;
          orderObject.Details[0].Sublines.push({
            RefId: Date.now().toString(),
            SublineTypeId: currentEle.sublineTypeId,
            Quantity: quantity,
            SurfaceId: currentEle.surfaceId,
            SublineObjectDescription: "",
            SublineObjectId: ((_currentEle$value = currentEle.value) === null || _currentEle$value === void 0 ? void 0 : _currentEle$value.omsKey) || ""
          });
        }
        // current motif
        if (currentEle.type === "motif") {
          var _currentEle$value2;
          var sublineText = ((_currentEle$value2 = currentEle.value) === null || _currentEle$value2 === void 0 ? void 0 : _currentEle$value2.name) || "";
          orderObject.Details[0].Sublines.push(_objectSpread(_objectSpread({}, newOrderSubObject), {}, {
            SublineTypeId: currentEle.sublineTypeId,
            SublineObjectDescription: sublineText,
            SublineObjectText: sublineText
          }));
        }

        // current monogram
        if (currentEle.type === "monogram") {
          var _currentEle$value3;
          var _sublineText = ((_currentEle$value3 = currentEle.value) === null || _currentEle$value3 === void 0 ? void 0 : _currentEle$value3.name) || "";
          orderObject.Details[0].Sublines.push(_objectSpread(_objectSpread({}, newOrderSubObject), {}, {
            SublineTypeId: currentEle.sublineTypeId,
            SublineObjectDescription: _sublineText,
            SublineObjectText: _sublineText
          }));
        }

        // current image
        if (currentEle.type === "image") {
          var _currentEle$value4;
          var _sublineText2 = (_currentEle$value4 = currentEle.value) !== null && _currentEle$value4 !== void 0 && _currentEle$value4.id ? currentEle.value.id : "image";
          orderObject.Details[0].Sublines.push(_objectSpread(_objectSpread({}, newOrderSubObject), {}, {
            ColorId: 94,
            // copied from personalize-vue summary object
            SublineTypeId: currentEle.sublineTypeId || 14,
            SublineObjectDescription: _sublineText2,
            SublineObjectText: _sublineText2
          }));
        }

        // current clipart
        if (currentEle.type === "clipart") {
          var _sublineText3 = currentEle.value ? currentEle.value : "clipart";
          orderObject.Details[0].Sublines.push(_objectSpread(_objectSpread({}, newOrderSubObject), {}, {
            ColorId: 94,
            // copied from personalize-vue designer clipart code
            SublineTypeId: currentEle.sublineTypeId || 14,
            SublineObjectDescription: _sublineText3,
            SublineObjectText: _sublineText3
          }));
        }
      }
    }
    return orderObject;
  } catch (err) {
    console.log(err);
    var errorMsg = err.error && err.error.error ? err.error.error : err.error ? err.error : err.message ? err.message : err;
    return {
      error: true,
      errorMessage: errorMsg
    };
  }
};
var priceProduct = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var pricer, orderPriceObject, productConfiguration, options, currentSessionId, _ref5$returnError, returnError, omsPrice, cloudPrice, errors, pricerObject, orderObject, partStructure, quantity, resp, _resp, _resp2, errorMsg;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          pricer = _ref5.pricer, orderPriceObject = _ref5.orderPriceObject, productConfiguration = _ref5.productConfiguration, options = _ref5.options, currentSessionId = _ref5.currentSessionId, _ref5$returnError = _ref5.returnError, returnError = _ref5$returnError === void 0 ? "false" : _ref5$returnError;
          _context3.prev = 1;
          cloudPrice = 0;
          errors = [];
          pricerObject = null;
          orderObject = {};
          if (!orderPriceObject) {
            partStructure = productConfiguration.configuredStructure;
            quantity = productConfiguration.qty;
            orderObject = {
              RefId: options.pricingDateTime.toString(),
              CustomerNumber: 338000,
              OrderDate: new Date(options.pricingDateTime).toISOString().slice(0, 10),
              Details: [{
                RefId: options.pricingDateTime.toString(),
                OrderedItemNumber: null,
                Quantity: quantity,
                Sublines: []
              }]
            };
            orderObject.Details[0].OrderedItemNumber = (partStructure === null || partStructure === void 0 ? void 0 : partStructure.paper) || null;
            orderObject.Details[0].UseId = (partStructure === null || partStructure === void 0 ? void 0 : partStructure.useId) || null;
            orderObject.Details[0].OccasionId = (partStructure === null || partStructure === void 0 ? void 0 : partStructure.occasionId) || null;
            orderObject.Details[0].KitParent = (partStructure === null || partStructure === void 0 ? void 0 : partStructure.kitParent) || false;
            orderObject.Details[0].KitComponent = (partStructure === null || partStructure === void 0 ? void 0 : partStructure.kitComponent) || false;
            orderObject.Details[0].BrandId = (partStructure === null || partStructure === void 0 ? void 0 : partStructure.brandId) || 1;
            orderObject.Details[0].VerseId = (partStructure === null || partStructure === void 0 ? void 0 : partStructure.verseId) || null;
            orderObject.Details[0].Sublines = [];
            pricerObject = getSublinesFromStructureElement({
              newStructure: partStructure,
              orderObject: orderObject,
              quantity: quantity
            });
          } else {
            pricerObject = orderPriceObject;
            pricerObject.OrderDate = new Date(options.pricingDateTime).toISOString().slice(0, 10);
          }
          if (!(pricer === "cloud")) {
            _context3.next = 22;
            break;
          }
          _context3.next = 10;
          return doCallPricerEngine(pricerObject, currentSessionId, returnError);
        case 10:
          resp = _context3.sent;
          if (resp.errors && resp.errors.length) errors = resp.errors;
          if (!(resp && resp.error)) {
            _context3.next = 21;
            break;
          }
          errors.push(resp.errorMessage);
          // if error in price engine then call pricer api
          if (!options.fallbackToOMS) {
            _context3.next = 19;
            break;
          }
          _context3.next = 17;
          return doCallPricerApi(pricerObject);
        case 17:
          _resp = _context3.sent;
          omsPrice = _resp.oldPrice;
        case 19:
          _context3.next = 22;
          break;
        case 21:
          cloudPrice = resp.newPrice;
        case 22:
          if (!(pricer === "oms" || options.compareToOMS)) {
            _context3.next = 31;
            break;
          }
          _context3.next = 25;
          return doCallPricerApi(pricerObject);
        case 25:
          _resp2 = _context3.sent;
          if (!(_resp2 && _resp2.error)) {
            _context3.next = 30;
            break;
          }
          return _context3.abrupt("return", {
            pricer: pricer,
            status: "error",
            error: _resp2.errorMessage,
            cloudPrice: cloudPrice,
            omsPrice: omsPrice
          });
        case 30:
          omsPrice = _resp2.oldPrice;
        case 31:
          if (!options.compareToOMS) {
            _context3.next = 35;
            break;
          }
          if (!(omsPrice !== cloudPrice)) {
            _context3.next = 35;
            break;
          }
          console.error("Error : old vs new price mismatched for this object", JSON.stringify({
            pricingOrder: pricerObject
          }));
          return _context3.abrupt("return", {
            pricer: pricer,
            status: "mismatch",
            error: "old vs new price mismatched",
            cloudPrice: cloudPrice,
            omsPrice: omsPrice
          });
        case 35:
          return _context3.abrupt("return", {
            pricer: pricer,
            status: "success",
            omsPrice: omsPrice,
            cloudPrice: cloudPrice,
            errors: errors
          });
        case 38:
          _context3.prev = 38;
          _context3.t0 = _context3["catch"](1);
          console.log(_context3.t0);
          errorMsg = _context3.t0.error && _context3.t0.error.error ? _context3.t0.error.error : _context3.t0.error ? _context3.t0.error : _context3.t0.message ? _context3.t0.message : _context3.t0;
          return _context3.abrupt("return", {
            pricer: pricer,
            status: "error",
            error: errorMsg
          });
        case 43:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 38]]);
  }));
  return function priceProduct(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
var getPriceDelta = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var defaultStructure, defaultAlternateStructure, mainStructure, alternateSturcture, currentSessionId, currentQuantity, surfaceType, _ref7$pricer, pricer, _ref7$returnError, returnError, pricingDateTime, pricerType, productConfiguration, options, priceSubtotal, priceBase, priceBaseEntirePart, priceSubtotalEntirePart, defaultPartPrice, defaultAlternatePrice, defaultPartPriceResp, defaultPartStructure, allDefaultCombineElements, defaultMainPriceResp, defaultMainPrice, errors, defaultMainStructure, currentPartPrice, currentMainPrice, currentAlternatePrice, currentPartPriceResp, currentMainPriceResp, currentConfiguredStructure, allCurrentCombineElements, isPaperChanged, elements, currentElements, defaultElements, i, element, ele;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          defaultStructure = _ref7.defaultStructure, defaultAlternateStructure = _ref7.defaultAlternateStructure, mainStructure = _ref7.mainStructure, alternateSturcture = _ref7.alternateSturcture, currentSessionId = _ref7.currentSessionId, currentQuantity = _ref7.currentQuantity, surfaceType = _ref7.surfaceType, _ref7$pricer = _ref7.pricer, pricer = _ref7$pricer === void 0 ? 'cloud' : _ref7$pricer, _ref7$returnError = _ref7.returnError, returnError = _ref7$returnError === void 0 ? "true" : _ref7$returnError, pricingDateTime = _ref7.pricingDateTime;
          _context4.prev = 1;
          console.info("price delta called...");
          pricerType = {
            "cloud": "cloudPrice",
            "oms": "omsPrice"
          };
          productConfiguration = {
            // configuredStructure: basePartStructure,
            qty: currentQuantity
          };
          options = {
            pricingDateTime: pricingDateTime ? pricingDateTime : Date.now(),
            // new Date('2021-02-02').getTime()
            fallbackToOMS: false,
            compareToOMS: false,
            audit: []
          };
          priceSubtotal = null;
          priceBase = null;
          priceBaseEntirePart = null;
          priceSubtotalEntirePart = null;
          defaultPartPrice = null;
          defaultAlternatePrice = null;
          defaultPartPriceResp = null;
          defaultPartStructure = {};
          allDefaultCombineElements = [];
          defaultMainPriceResp = null;
          defaultMainPrice = null;
          errors = [];
          defaultMainStructure = {};
          allDefaultCombineElements = [].concat(_toConsumableArray(defaultStructure.elements), _toConsumableArray(defaultAlternateStructure.elements));
          defaultPartStructure = Object.assign({}, defaultStructure, {
            elements: allDefaultCombineElements
          });
          productConfiguration = {
            configuredStructure: defaultPartStructure,
            qty: currentQuantity
          };
          console.log("getting price for default part...");
          _context4.next = 27;
          return priceProduct({
            pricer: pricer,
            productConfiguration: productConfiguration,
            options: options,
            currentSessionId: currentSessionId,
            returnError: returnError
          });
        case 27:
          defaultPartPriceResp = _context4.sent;
          if (defaultPartPriceResp.errors) errors = errors.concat(defaultPartPriceResp.errors);
          if (defaultPartPriceResp.error) errors = errors.concat([defaultPartPriceResp.error]);
          defaultPartPrice = defaultPartPriceResp[pricerType[pricer]];
          // }

          defaultMainStructure = Object.assign({}, defaultStructure);
          productConfiguration = {
            configuredStructure: defaultMainStructure,
            qty: currentQuantity
          };
          console.log("getting price for default structure ...");
          _context4.next = 36;
          return priceProduct({
            pricer: pricer,
            productConfiguration: productConfiguration,
            options: options,
            currentSessionId: currentSessionId,
            returnError: returnError
          });
        case 36:
          defaultMainPriceResp = _context4.sent;
          if (defaultMainPriceResp.errors) errors = errors.concat(defaultMainPriceResp.errors);
          if (defaultMainPriceResp.error) errors = errors.concat([defaultMainPriceResp.error]);
          defaultMainPrice = defaultMainPriceResp[pricerType[pricer]];
          if (surfaceType == "alternateSurface") {
            defaultAlternatePrice = defaultPartPrice - defaultMainPrice;
          }
          currentPartPrice = null;
          currentMainPrice = null;
          currentAlternatePrice = null;
          currentPartPriceResp = null;
          currentMainPriceResp = null;
          currentConfiguredStructure = {};
          allCurrentCombineElements = [];
          allCurrentCombineElements = [].concat(_toConsumableArray(mainStructure.elements), _toConsumableArray(alternateSturcture.elements));
          currentConfiguredStructure = Object.assign({}, mainStructure, {
            elements: allCurrentCombineElements
          });
          productConfiguration = {
            configuredStructure: currentConfiguredStructure,
            qty: currentQuantity
          };
          console.log("getting price for main part...");
          _context4.next = 54;
          return priceProduct({
            pricer: pricer,
            productConfiguration: productConfiguration,
            options: options,
            currentSessionId: currentSessionId,
            returnError: returnError
          });
        case 54:
          currentPartPriceResp = _context4.sent;
          if (currentPartPriceResp.errors) errors = errors.concat(currentPartPriceResp.errors);
          if (currentPartPriceResp.error) errors = errors.concat([currentPartPriceResp.error]);
          currentPartPrice = currentPartPriceResp[pricerType[pricer]];
          currentConfiguredStructure = Object.assign({}, mainStructure);
          productConfiguration = {
            configuredStructure: currentConfiguredStructure,
            qty: currentQuantity
          };
          console.log("getting price for current structure...");
          _context4.next = 63;
          return priceProduct({
            pricer: pricer,
            productConfiguration: productConfiguration,
            options: options,
            currentSessionId: currentSessionId,
            returnError: returnError
          });
        case 63:
          currentMainPriceResp = _context4.sent;
          if (currentMainPriceResp.errors) errors = errors.concat(currentMainPriceResp.errors);
          if (currentMainPriceResp.error) errors = errors.concat([currentMainPriceResp.error]);
          currentMainPrice = currentMainPriceResp[pricerType[pricer]];
          if (surfaceType == "alternateSurface") {
            currentAlternatePrice = currentPartPrice - currentMainPrice;
          }
          isPaperChanged = defaultStructure.paper != mainStructure.paper;
          elements = [];
          currentElements = [];
          defaultElements = [];
          if (surfaceType == "alternateSurface") {
            currentElements = alternateSturcture.elements;
            defaultElements = defaultAlternateStructure.elements;
            // defaultStructure, defaultAlternateStructure, mainStructure,
          } else {
            currentElements = mainStructure.elements;
            defaultElements = defaultStructure.elements;
          }
          // defaultStructure, defaultAlternateStructure

          for (i = 0; i < currentElements.length; i++) {
            element = currentElements[i];
            ele = getElemenWithStatus({
              currentElement: element,
              elements: defaultElements
            });
            elements.push(ele);
          }
          if (surfaceType == "alternateSurface") {
            priceBase = defaultAlternatePrice;
            priceSubtotal = currentAlternatePrice;
            priceBaseEntirePart = defaultPartPrice;
            priceSubtotalEntirePart = currentPartPrice;
          } else {
            priceBase = defaultMainPrice;
            priceSubtotal = currentMainPrice;
            priceBaseEntirePart = defaultPartPrice;
            priceSubtotalEntirePart = currentPartPrice;
          }
          return _context4.abrupt("return", {
            priceBaseEntirePart: priceBaseEntirePart,
            priceSubtotalEntirePart: priceSubtotalEntirePart,
            priceDeltaEntirePart: priceSubtotalEntirePart - priceBaseEntirePart,
            priceBase: priceBase,
            priceSubtotal: priceSubtotal,
            priceDelta: priceSubtotal - priceBase,
            elements: elements,
            paper: {
              type: "paper",
              value: mainStructure.paper,
              width: defaultStructure.paperWidth,
              height: defaultStructure.paperHeight,
              status: isPaperChanged ? "changed" : "unchanged"
            },
            name: defaultStructure.name,
            errors: errors.length ? errors : null
          });
        case 78:
          _context4.prev = 78;
          _context4.t0 = _context4["catch"](1);
          console.error("error in getting delta price", _context4.t0);
          return _context4.abrupt("return", {
            error: true,
            message: _context4.t0
          });
        case 82:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 78]]);
  }));
  return function getPriceDelta(_x7) {
    return _ref8.apply(this, arguments);
  };
}();
var getElemenWithStatus = function getElemenWithStatus(_ref9) {
  var currentElement = _ref9.currentElement,
    elements = _ref9.elements;
  var isOptional = currentElement.isOptional ? "" + currentElement.isOptional : null;
  var isOptionalAdded = currentElement.isOptionalAdded ? "" + currentElement.isOptionalAdded : null;
  var removed = currentElement.removed ? "" + currentElement.removed : null;
  var status = null;
  var element = {
    name: currentElement.name,
    color: currentElement.color,
    print: currentElement.print,
    new_value: currentElement.value,
    surfaceId: currentElement.surfaceId
  };
  var matchElement = elements.filter(function (ele) {
    return ele.name == currentElement.name;
  })[0];
  if (matchElement) {
    element.old_value = matchElement.value;
  }
  if (removed && removed == "true") {
    element.status = "removed";
    return element;
  }
  if (isOptional && isOptional == "true") {
    if (isOptionalAdded && isOptionalAdded == "true") {
      element.status = "added";
    } else {
      element.status = "unchanged";
      element.hide = true, element.isOptional = true;
    }
    return element;
  }
  if (matchElement) {
    if (currentElement.type == "text") {
      if (currentElement.value != matchElement.value || isColorChanged(currentElement.color, matchElement.color) || isPrintChanged(currentElement.print, matchElement.print)) status = "changed";
    }
    if (currentElement.type == "motif") {
      if (currentElement.value.name != matchElement.value.name || isColorChanged(currentElement.color, matchElement.color) || isPrintChanged(currentElement.print, matchElement.print)) status = "changed";
    }
    if (currentElement.type == "monogram") {
      if (currentElement.value.name != matchElement.value.name || isColorChanged(currentElement.color, matchElement.color) || isPrintChanged(currentElement.print, matchElement.print)) status = "changed";
    }
    if (currentElement.type == "image") {
      if (matchElement.value) {
        if (currentElement.value.name != matchElement.value.name || isPrintChanged(currentElement.print, matchElement.print)) status = "changed";else {
          status = "unchanged";
        }
      } else if (currentElement.value) status = "changed";else status = "unchanged";
    }
    if (currentElement.type == "clipart") {
      // if (currentElement.value.name != matchElement.value.name || isPrintChanged(currentElement.print, matchElement.print))
      status = "unchanged";
    }
  }
  if (currentElement.type == "liner") {
    // if (currentElement.value.name != matchElement.value.name || isPrintChanged(currentElement.print, matchElement.print))
    status = "added";
  }
  element.status = status ? status : "unchanged";
  return element;
};
var isColorChanged = function isColorChanged(currentColor, color) {
  return currentColor.cid != color.cid;
};
var isPrintChanged = function isPrintChanged(currentPrint, print) {
  return currentPrint.name != print.name;
};

var processors = {
  Thermography: 1,
  Engraving: 2,
  Letterpress: 5,
  Digital: 21,
  Embossing: 6,
  "Flat Print": 7,
  Flat: 7,
  Foil: 15
};
var printShortName = {
  Thermography: "T",
  Engraving: "E",
  Letterpress: "L",
  Digital: "G",
  Embossing: "B",
  "Flat Print": "F",
  Flat: "F",
  Foil: "R"
};
var SublineTypeIds = {
  text: 14,
  motif: 14,
  monogram: 14,
  liner: 8,
  image: 14,
  clipart: 14
};
var _updateElement = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var element, elementProperties, partAssets, paperAssets, surfaceId, _dataVisible, dataFontStyle, fontObject, dataSelectedFontFamily, dataSelectedFontSize, dataSelectedLetterSpacing, dataSelectedLineHeight, dataIsStyleLinked, dataColorStyle, dataProcessStyle, dataElementName, dataVisible, dataSelectedColor, dataElementUniqueId, dataSelectedPaper, selectedPaperObj, dataPaper, options, p, dataFinish, dataFinishObj, linerList, liners, i, dataColorTags, colorTags, colorResp, dataDefaultText, _dataOptional, _dataOptionalAdded, dataOptional, dataOptionalAdded, _dataSelectedColor, defaultText, dataSelectedMotif, dataMotif, _dataSelectedColor2, motifOptions, motif, option, _option, motifs, _p, dataSelectedMonogram, dataMonogram, _dataSelectedColor3, monogramOptions, monogram, _option2, _option3, monograms, _p2, dataImage, _options, images, dataType, dataClipartImage, url, n;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          element = _ref.element, elementProperties = _ref.elementProperties, partAssets = _ref.partAssets, paperAssets = _ref.paperAssets, surfaceId = _ref.surfaceId;
          _context.prev = 1;
          if (!element.attributes) {
            _context.next = 196;
            break;
          }
          dataFontStyle = null;
          fontObject = null;
          dataFontStyle = element.attributes.filter(function (attribute) {
            return attribute.key === "data-font-style";
          })[0];
          if (dataFontStyle && dataFontStyle.value) {
            dataFontStyle = decodeURIComponent(dataFontStyle.value);
            dataSelectedFontFamily = element.attributes.filter(function (attribute) {
              return attribute.key === "data-selected-font-family";
            })[0];
            dataSelectedFontSize = element.attributes.filter(function (attribute) {
              return attribute.key === "data-selected-font-size";
            })[0];
            dataSelectedLetterSpacing = element.attributes.filter(function (attribute) {
              return attribute.key === "data-selected-letter-spacing";
            })[0];
            dataSelectedLineHeight = element.attributes.filter(function (attribute) {
              return attribute.key === "data-selected-line-height";
            })[0];
            if (["undefined", undefined, null, "null"].includes(dataSelectedLineHeight.value)) dataSelectedLineHeight.value = undefined;
            fontObject = {
              name: dataSelectedFontFamily.value,
              defaultValue: dataSelectedFontSize.value,
              letterSpacing: dataSelectedLetterSpacing.value,
              lineHeight: dataSelectedLineHeight.value
            };
          }
          dataIsStyleLinked = null;
          dataIsStyleLinked = element.attributes.filter(function (attribute) {
            return attribute.key === "data-is-style-linked";
          })[0];
          if (dataIsStyleLinked && dataIsStyleLinked.value) {
            dataIsStyleLinked = decodeURIComponent(dataIsStyleLinked.value);
          }
          dataColorStyle = null;
          dataColorStyle = element.attributes.filter(function (attribute) {
            return attribute.key === "data-color-style";
          })[0];
          if (dataColorStyle && dataColorStyle.value) {
            dataColorStyle = decodeURIComponent(dataColorStyle.value);
          }
          dataProcessStyle = null;
          dataProcessStyle = element.attributes.filter(function (attribute) {
            return attribute.key === "data-process-style";
          })[0];
          if (dataProcessStyle && dataProcessStyle.value) {
            dataProcessStyle = decodeURIComponent(dataProcessStyle.value);
          }
          dataElementName = null;
          dataElementName = element.attributes.filter(function (attribute) {
            return attribute.key === "data-element-name";
          })[0];
          if (dataElementName && dataElementName.value) {
            dataElementName = decodeURIComponent(dataElementName.value);
            dataElementName = getName({
              elements: partAssets.elements,
              name: dataElementName
            });
          }
          //  else{
          //  console.log("data element name not present")
          //  }
          dataVisible = null;
          dataVisible = element.attributes.filter(function (attribute) {
            return attribute.key === "data-visible";
          })[0];
          dataVisible = dataVisible && dataVisible.value !== "undefined" ? JSON.parse(dataVisible.value.replace(/'/g, '"')) : (_dataVisible = dataVisible) === null || _dataVisible === void 0 || (_dataVisible = _dataVisible.value) === null || _dataVisible === void 0 ? void 0 : _dataVisible.replace(/'/g, '"');
          dataSelectedColor = element.attributes.filter(function (attribute) {
            return attribute.key === "data-color";
          });
          dataSelectedColor = dataSelectedColor && dataSelectedColor[0] ? dataSelectedColor[0] : {};
          dataElementUniqueId = element.attributes.filter(function (attribute) {
            return attribute.key === "data-element-unique-id";
          });
          dataElementUniqueId = dataElementUniqueId && dataElementUniqueId[0] ? dataElementUniqueId[0].value : null;
          dataSelectedPaper = element.attributes.filter(function (attribute) {
            return attribute.key === "data-selected-paper-type";
          })[0];
          if (dataSelectedPaper && dataSelectedPaper.value) {
            selectedPaperObj = JSON.parse(dataSelectedPaper.value.replace(/'/g, '"'));
            partAssets.paper = selectedPaperObj.name;
            if (selectedPaperObj && partAssets.papers) {
              partAssets.papers.unshift(selectedPaperObj.name);
              paperAssets.unshift(selectedPaperObj.name), partAssets.paper = selectedPaperObj.name;
              partAssets.paperWidth = selectedPaperObj.width;
              partAssets.paperHeight = selectedPaperObj.height;
            }
          }
          dataPaper = element.attributes.filter(function (attribute) {
            return attribute.key === "data-paper";
          })[0];
          if (dataPaper && dataPaper.value) {
            options = JSON.parse(dataPaper.value.replace(/'/g, '"'));
            for (p = 0; p < options.paperOptions.length; p++) {
              if (partAssets.papers && !partAssets.papers.includes(options.paperOptions[p].name)) partAssets.papers.push(options.paperOptions[p].name);
              paperAssets.push(options.paperOptions[p].name);
            }
          }
          dataFinish = element.attributes.filter(function (attribute) {
            return attribute.key === "data-finish";
          })[0];
          if (!(dataFinish && dataFinish.value)) {
            _context.next = 41;
            break;
          }
          dataFinishObj = JSON.parse(dataFinish.value.replace(/'/g, '"'));
          if (!(dataFinishObj && dataFinishObj.isLiner && dataFinishObj.linerTags)) {
            _context.next = 41;
            break;
          }
          _context.next = 36;
          return doFetchLinerList({
            tags: dataFinishObj.linerTags.join(",")
          });
        case 36:
          linerList = _context.sent;
          liners = [];
          for (i = 0; i < linerList.length; i++) {
            //if (!partAssets.liners.includes(linerList[i].liner_oms_key))
            liners.push({
              oms_key: linerList[i].liner_oms_key,
              name: linerList[i].name,
              liner_id: linerList[i].liner_id,
              id: linerList[i].id
            });
            paperAssets.push(linerList[i].liner_id);
          }
          dataElementName = dataElementName ? dataElementName : getName({
            elements: partAssets.elements,
            name: "liner"
          });
          partAssets.elements.push({
            type: "liner",
            values: liners,
            value: null,
            sublineTypeId: SublineTypeIds["liner"],
            surfaceId: surfaceId,
            name: dataElementName,
            styleLinked: dataIsStyleLinked,
            processStyle: dataProcessStyle,
            colorStyle: dataColorStyle,
            fontStyle: dataFontStyle
          });
        case 41:
          dataColorTags = element.attributes.filter(function (attribute) {
            return attribute.key === "data-color-tags";
          })[0];
          if (!(dataColorTags && dataColorTags.value)) {
            _context.next = 49;
            break;
          }
          colorTags = JSON.parse(dataColorTags.value.replace(/'/g, '"'));
          if (!colorTags.length) {
            _context.next = 49;
            break;
          }
          _context.next = 47;
          return doFetchColorsByTags(colorTags);
        case 47:
          colorResp = _context.sent;
          if (colorResp && colorResp.length) {
            elementProperties.colors = _toConsumableArray(colorResp);
          }
        case 49:
          // end of paper assets
          // for text assets
          dataDefaultText = element.attributes.filter(function (attribute) {
            return attribute.key === "data-text";
          })[0];
          if (!(dataDefaultText && dataDefaultText.value)) {
            _context.next = 92;
            break;
          }
          dataOptional = element.attributes.filter(function (attribute) {
            return attribute.key === "data-optional";
          })[0];
          dataOptional = dataOptional && dataOptional.value !== "undefined" ? JSON.parse(dataOptional.value.replace(/'/g, '"')) : (_dataOptional = dataOptional) === null || _dataOptional === void 0 ? void 0 : _dataOptional.value.replace(/'/g, '"');
          dataOptionalAdded = element.attributes.filter(function (attribute) {
            return attribute.key === "data-optional-added";
          })[0];
          dataOptionalAdded = (_dataOptionalAdded = dataOptionalAdded) === null || _dataOptionalAdded === void 0 ? void 0 : _dataOptionalAdded.value.replace(/'/g, '"');
          dataElementName = dataElementName ? dataElementName : getName({
            elements: partAssets.elements,
            name: "text"
          });
          _dataSelectedColor = element.attributes.filter(function (attribute) {
            return attribute.key === "data-color";
          })[0];
          defaultText = JSON.parse(dataDefaultText.value.replace(/'/g, '"'));
          if (!defaultText.length) {
            _context.next = 92;
            break;
          }
          _context.t0 = partAssets.elements;
          _context.t1 = _defineProperty;
          _context.t2 = _defineProperty;
          _context.t3 = _defineProperty;
          _context.t4 = _defineProperty;
          _context.t5 = _defineProperty;
          _context.t6 = defaultText.map(function (text) {
            return unescape(text);
          }).join("\n");
          _context.t7 = elementProperties.colors;
          _context.t8 = JSON.parse(_dataSelectedColor.value.replace(/'/g, '"'));
          _context.t9 = getSelectedPrintOption(element);
          _context.t10 = fontObject;
          _context.next = 72;
          return getDataPrintOptions(element);
        case 72:
          _context.t11 = _context.sent;
          _context.t12 = SublineTypeIds["text"];
          _context.t13 = surfaceId;
          _context.t14 = defaultText.map(function (text) {
            return unescape(text);
          }).join("\n").length === 0;
          _context.t15 = dataElementUniqueId;
          _context.t16 = dataElementName;
          _context.t17 = dataOptional ? dataOptional : null;
          _context.t18 = dataOptionalAdded ? dataOptionalAdded : null;
          _context.t19 = {
            type: "text",
            value: _context.t6,
            colors: _context.t7,
            color: _context.t8,
            print: _context.t9,
            font: _context.t10,
            prints: _context.t11,
            sublineTypeId: _context.t12,
            surfaceId: _context.t13,
            removed: _context.t14,
            elementId: _context.t15,
            name: _context.t16,
            isOptional: _context.t17,
            isOptionalAdded: _context.t18
          };
          _context.t20 = dataElementName;
          _context.t21 = (0, _context.t5)(_context.t19, "name", _context.t20);
          _context.t22 = dataIsStyleLinked;
          _context.t23 = (0, _context.t4)(_context.t21, "styleLinked", _context.t22);
          _context.t24 = dataProcessStyle;
          _context.t25 = (0, _context.t3)(_context.t23, "processStyle", _context.t24);
          _context.t26 = dataColorStyle;
          _context.t27 = (0, _context.t2)(_context.t25, "colorStyle", _context.t26);
          _context.t28 = dataFontStyle;
          _context.t29 = (0, _context.t1)(_context.t27, "fontStyle", _context.t28);
          _context.t0.push.call(_context.t0, _context.t29);
        case 92:
          // for motif assets
          dataSelectedMotif = element.attributes.filter(function (attribute) {
            return attribute.key === "data-selected-motif";
          })[0];
          dataMotif = element.attributes.filter(function (attribute) {
            return attribute.key === "data-motif";
          })[0];
          if (!(dataMotif && dataMotif.value)) {
            _context.next = 121;
            break;
          }
          _dataSelectedColor2 = element.attributes.filter(function (attribute) {
            return attribute.key === "data-color";
          })[0];
          motifOptions = JSON.parse(dataMotif.value.replace(/'/g, '"'));
          motif = {};
          if (dataSelectedMotif && dataSelectedMotif.value) {
            option = JSON.parse(dataSelectedMotif.value.replace(/'/g, '"'));
            motif = {
              name: option.name,
              id: option.id,
              url: option.url
            };
          } else {
            _option = motifOptions.motifOptions[0];
            motif = {
              name: _option.name,
              id: _option.id,
              url: _option.url
            };
          }
          motifs = [];
          for (_p = 0; _p < motifOptions.motifOptions.length; _p++) {
            motifs.push({
              name: motifOptions.motifOptions[_p].name,
              id: motifOptions.motifOptions[_p].id,
              url: motifOptions.motifOptions[_p].url
            });
          }
          dataElementName = dataElementName ? dataElementName : getName({
            elements: partAssets.elements,
            name: "motif"
          });
          _context.t30 = partAssets.elements;
          _context.t31 = motifs;
          _context.t32 = motif;
          _context.t33 = elementProperties.colors;
          _context.t34 = JSON.parse(_dataSelectedColor2.value.replace(/'/g, '"'));
          _context.t35 = getSelectedPrintOption(element);
          _context.next = 110;
          return getDataPrintOptions(element);
        case 110:
          _context.t36 = _context.sent;
          _context.t37 = SublineTypeIds["motif"];
          _context.t38 = surfaceId;
          _context.t39 = dataElementUniqueId;
          _context.t40 = dataElementName;
          _context.t41 = dataIsStyleLinked;
          _context.t42 = dataProcessStyle;
          _context.t43 = dataColorStyle;
          _context.t44 = dataFontStyle;
          _context.t45 = {
            type: "motif",
            values: _context.t31,
            value: _context.t32,
            colors: _context.t33,
            color: _context.t34,
            print: _context.t35,
            prints: _context.t36,
            sublineTypeId: _context.t37,
            surfaceId: _context.t38,
            elementId: _context.t39,
            name: _context.t40,
            styleLinked: _context.t41,
            processStyle: _context.t42,
            colorStyle: _context.t43,
            fontStyle: _context.t44
          };
          _context.t30.push.call(_context.t30, _context.t45);
        case 121:
          // for monogram assets
          dataSelectedMonogram = element.attributes.filter(function (attribute) {
            return attribute.key === "data-selected-monogram";
          })[0];
          dataMonogram = element.attributes.filter(function (attribute) {
            return attribute.key === "data-monogram";
          })[0];
          if (!(dataMonogram && dataMonogram.value)) {
            _context.next = 151;
            break;
          }
          _dataSelectedColor3 = element.attributes.filter(function (attribute) {
            return attribute.key === "data-color";
          })[0];
          monogramOptions = JSON.parse(dataMonogram.value.replace(/'/g, '"'));
          monogram = {};
          if (dataSelectedMonogram && dataSelectedMonogram.value) {
            _option2 = JSON.parse(dataSelectedMonogram.value.replace(/'/g, '"'));
            monogram = {
              name: _option2.name,
              id: _option2.id,
              url: _option2.url
            };
          } else {
            _option3 = monogramOptions.monogramOptions[0];
            monogram = {
              name: _option3.name,
              id: _option3.id,
              url: _option3.url
            };
          }
          monograms = [];
          for (_p2 = 0; _p2 < monogramOptions.monogramOptions.length; _p2++) {
            monograms.push({
              name: monogramOptions.monogramOptions[_p2].name,
              id: monogramOptions.monogramOptions[_p2].id,
              url: monogramOptions.monogramOptions[_p2].url
            });
          }
          dataElementName = dataElementName ? dataElementName : getName({
            elements: partAssets.elements,
            name: "monogram"
          });
          _context.t46 = partAssets.elements;
          _context.t47 = monograms;
          _context.t48 = monogram;
          _context.t49 = elementProperties.colors;
          _context.t50 = JSON.parse(_dataSelectedColor3.value.replace(/'/g, '"'));
          _context.t51 = getSelectedPrintOption(element);
          _context.t52 = fontObject;
          _context.next = 140;
          return getDataPrintOptions(element);
        case 140:
          _context.t53 = _context.sent;
          _context.t54 = SublineTypeIds["monogram"];
          _context.t55 = surfaceId;
          _context.t56 = dataElementUniqueId;
          _context.t57 = dataElementName;
          _context.t58 = dataIsStyleLinked;
          _context.t59 = dataProcessStyle;
          _context.t60 = dataColorStyle;
          _context.t61 = dataFontStyle;
          _context.t62 = {
            type: "monogram",
            values: _context.t47,
            value: _context.t48,
            colors: _context.t49,
            color: _context.t50,
            print: _context.t51,
            font: _context.t52,
            prints: _context.t53,
            sublineTypeId: _context.t54,
            surfaceId: _context.t55,
            elementId: _context.t56,
            name: _context.t57,
            styleLinked: _context.t58,
            processStyle: _context.t59,
            colorStyle: _context.t60,
            fontStyle: _context.t61
          };
          _context.t46.push.call(_context.t46, _context.t62);
        case 151:
          // for image assets
          dataImage = element.attributes.filter(function (attribute) {
            return attribute.key === "data-image";
          })[0];
          if (!(dataImage && dataImage.value)) {
            _context.next = 174;
            break;
          }
          _options = JSON.parse(dataImage.value.replace(/'/g, '"'));
          images = [];
          if (_options && _options.selectedImage) {
            images.push({
              name: _options.selectedImage.name,
              id: _options.selectedImage.id,
              url: _options.selectedImage.url
            });
          }
          dataElementName = dataElementName ? dataElementName : getName({
            elements: partAssets.elements,
            name: "image"
          });
          _context.t63 = partAssets.elements;
          _context.t64 = images;
          _context.t65 = images[0];
          _context.t66 = getSelectedPrintOption(element);
          _context.next = 163;
          return getDataPrintOptions(element);
        case 163:
          _context.t67 = _context.sent;
          _context.t68 = SublineTypeIds["image"];
          _context.t69 = surfaceId;
          _context.t70 = dataElementUniqueId;
          _context.t71 = dataElementName;
          _context.t72 = dataIsStyleLinked;
          _context.t73 = dataProcessStyle;
          _context.t74 = dataColorStyle;
          _context.t75 = dataFontStyle;
          _context.t76 = {
            type: "image",
            values: _context.t64,
            value: _context.t65,
            print: _context.t66,
            prints: _context.t67,
            sublineTypeId: _context.t68,
            surfaceId: _context.t69,
            elementId: _context.t70,
            name: _context.t71,
            styleLinked: _context.t72,
            processStyle: _context.t73,
            colorStyle: _context.t74,
            fontStyle: _context.t75
          };
          _context.t63.push.call(_context.t63, _context.t76);
        case 174:
          // for image assets
          dataType = element.attributes.filter(function (attribute) {
            return attribute.key === "data-type";
          })[0];
          if (!(dataType && dataType.value === "clipart")) {
            _context.next = 196;
            break;
          }
          dataClipartImage = element.attributes.filter(function (attribute) {
            return attribute.key === "data-clipart-image-url";
          })[0];
          url = dataClipartImage ? dataClipartImage.value : null;
          dataElementName = dataElementName ? dataElementName : getName({
            elements: partAssets.elements,
            name: "clipart"
          });
          _context.t77 = partAssets.elements;
          _context.t78 = url ? encodeURIComponent(url) : null;
          _context.t79 = url ? encodeURIComponent(url) : null;
          _context.next = 184;
          return getDataPrintOptions(element);
        case 184:
          _context.t80 = _context.sent;
          _context.t81 = getSelectedPrintOption(element);
          _context.t82 = SublineTypeIds["clipart"];
          _context.t83 = surfaceId;
          _context.t84 = dataElementUniqueId;
          _context.t85 = dataElementName;
          _context.t86 = dataIsStyleLinked;
          _context.t87 = dataProcessStyle;
          _context.t88 = dataColorStyle;
          _context.t89 = dataFontStyle;
          _context.t90 = {
            type: "clipart",
            values: _context.t78,
            value: _context.t79,
            prints: _context.t80,
            print: _context.t81,
            sublineTypeId: _context.t82,
            surfaceId: _context.t83,
            elementId: _context.t84,
            name: _context.t85,
            styleLinked: _context.t86,
            processStyle: _context.t87,
            colorStyle: _context.t88,
            fontStyle: _context.t89
          };
          _context.t77.push.call(_context.t77, _context.t90);
        case 196:
          _context.next = 201;
          break;
        case 198:
          _context.prev = 198;
          _context.t91 = _context["catch"](1);
          console.log("error in attributes", _context.t91);
        case 201:
          if (!element.children) {
            _context.next = 209;
            break;
          }
          n = 0;
        case 203:
          if (!(n < element.children.length)) {
            _context.next = 209;
            break;
          }
          _context.next = 206;
          return _updateElement({
            element: element.children[n],
            elementProperties: elementProperties,
            partAssets: partAssets,
            paperAssets: paperAssets,
            surfaceId: surfaceId
          });
        case 206:
          n++;
          _context.next = 203;
          break;
        case 209:
          return _context.abrupt("return", element);
        case 210:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 198]]);
  }));
  return function updateElement(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getDataPrintOptions = function getDataPrintOptions(element) {
  var prints = [];
  if (element && element.attributes) {
    var dataPrint = element.attributes.filter(function (attribute) {
      return attribute.key === "data-print";
    })[0];
    if (dataPrint && dataPrint.value) {
      var options = JSON.parse(dataPrint.value.replace(/'/g, '"'));
      for (var p = 0; p < options.printTypeOptions.length; p++) {
        prints.push({
          name: options.printTypeOptions[p],
          processId: processors[options.printTypeOptions[p]],
          shortName: printShortName[options.printTypeOptions[p]]
        });
      }
    }
  }
  return prints;
};
var getName = function getName(_ref3) {
  var elements = _ref3.elements,
    name = _ref3.name;
  try {
    if (elements && elements.length) {
      var count = elements.filter(function (ele) {
        return ele.name.split('-')[0] === name;
      });
      if (count.length) {
        console.log("name present", count);
        return name + "-" + count.length;
      } else return name;
    }
  } catch (error) {
    console.log("error in get name", error);
  }
  return name;
};
var getSelectedPrintOption = function getSelectedPrintOption(element) {
  var print = {};
  if (element && element.attributes) {
    var dataPrint = element.attributes.filter(function (attribute) {
      return attribute.key === "data-selected-print-type";
    })[0];
    if (dataPrint && dataPrint.value) {
      var option = dataPrint.value.replace(/'/g, '"');
      // for (let p = 0; p < options.printTypeOptions.length; p++) {
      print = {
        name: option,
        processId: processors[option],
        shortName: printShortName[option]
      };
      // }
    }
  }
  return print;
};

// this function create a part structure from element All available options / properties
var createPartStrucureFromSvgElementAllOptions = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(svgData, partAssets, paperAssets, surfaceId) {
    var elementProperties, parsedSvg, svgElement, doctType, j, children;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          elementProperties = {};
          parsedSvg = svgData;
          svgElement = parsedSvg.filter(function (element) {
            return element.tagName === "svg";
          })[0];
          doctType = parsedSvg.filter(function (element) {
            return element.tagName === "!doctype";
          })[0];
          doctType.tagName = "!DOCTYPE";
          if (!svgElement.children) {
            _context2.next = 16;
            break;
          }
          console.log("children.length", svgElement.children.length);
          j = 0;
        case 9:
          if (!(j < svgElement.children.length)) {
            _context2.next = 16;
            break;
          }
          children = svgElement.children[j];
          _context2.next = 13;
          return _updateElement({
            element: children,
            elementProperties: elementProperties,
            partAssets: partAssets,
            paperAssets: paperAssets,
            surfaceId: surfaceId
          });
        case 13:
          j++;
          _context2.next = 9;
          break;
        case 16:
          return _context2.abrupt("return", {
            partAssets: JSON.parse(JSON.stringify(partAssets))
          });
        case 19:
          _context2.prev = 19;
          _context2.t0 = _context2["catch"](0);
          throw _context2.t0;
        case 22:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 19]]);
  }));
  return function createPartStrucureFromSvgElementAllOptions(_x2, _x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var product = {
  name: 'Crane-pricer',
  version: '2.1.0'
};

console.info("Current version for crane pricer ", product.version);

// window.pricerRecordsDefault = {
//   DieTypeProcessXRef: {
//     "1": "13",
//     "2": "9",
//     "3": "20",
//     "4": "0"
//   },
//   ItemPriceBase: {
//     "1": "185590",
//     "2": "0",
//     "3": "2024-09-04 00:00:00",
//     "4": "2030-01-01 00:00:00",
//     "5": "True"
//   },
//   ItemPriceException: {
//     "LastChanged": "2024-08-19 11:22:35.337000000",
//     "ReplicationID": "0",
//     "AvailabilityEndTs": "2029-12-31T18:30:00.000Z",
//     "OrderedItemNumber": "LE1111",
//     "AvailabilityStartTs": "2024-09-03T18:30:00.000Z",
//     "PriceExceptionPer25": "22.1000",
//     "ItemPriceExceptionId": "12190",
//     "ItemPriceExceptionIsActive": "False",
//     "ItemPriceExceptionAvailabilistyEnd": "2030-01-01 00:00:00",
//     "ItemPriceExceptionAvailabilityStart": "2024-09-04 00:00:00"
//   },
//   ItemXRef: {
//     "1": "LC3111",
//     "2": "18241",
//     "3": "2013-11-6",
//     "4": "2030-1-1",
//     "5": "True",
//     "6": "185590",
//     "7": "A"
//   },
//   LinerPricingCategoryMaster: {
//     "1": "A",
//     "2": "12",
//     "3": "2024-09-04 00:00:00",
//     "4": "2035-01-01 00:00:00",
//     "5": "True"
//   },
//   OccasionUseXRef: {
//     "1": "2",
//     "2": "2",
//     "3": "10",
//     "4": "1",
//     "5": "9"
//   },
//   PriceSublineFlatXRef: {
//     "1": "30",
//     "2": "True",
//     "3": "7",
//     "4": "2035-12-31 00:00:00",
//     "5": "2024-09-04 00:00:00",
//     "6": "5"
//   },
//   PriceSublineQuantityXRef: {
//     "1": "True",
//     "2": "15",
//     "3": "25",
//     "4": "2035-12-31 00:00:00",
//     "5": "25",
//     "6": "2024-09-04 00:00:00",
//     "7": "4",
//     "8": "5"
//   },
//   PriceSublineTypeMaster: {
//     "1": "True",
//     "2": "10",
//     "3": "2035-12-31 00:00:00",
//     "4": "2010-01-01 00:00:00",
//     "5": "5",
//     "6": "BM",
//     "7": "1"
//   },
//   PricingSublineProcessHierarchyXRef: {
//     "1": "13",
//     "2": "10",
//     "3": "2017-01-01 00:00:00",
//     "4": "2035-12-31 00:00:00",
//     "5": "True",
//     "6": "301"
//   },
//   ProcessMaster: {
//     "1": "13",
//     "2": "1900-01-01 0:00:00",
//     "3": "2035-01-01 0:00:00",
//     "4": "TRUE",
//     "5": "FALSE",
//     "6": "0",
//     "7": "0"
//   },
//   RateMaster: {
//     "1": "TRUE",
//     "2": "10",
//     "3": "2006-08-14 18:53:40.293000000",
//     "4": "2035-01-01 00:00:00",
//     "5": ".60"
//   },
//   RateQuantity: {
//     "1": "13",
//     "2": "10",
//     "3": "525",
//     "4": "501",
//     "5": "2024-09-04 00:00:00",
//     "6": "2035-01-01 00:00:00",
//     "7": "True",
//     "8": "20",
//     "9": "67762"
//   },
//   SuppliedMaterialDetail: {
//     "1": "1057",
//     "2": "2008-01-19 06:14:34.020000000",
//     "3": "2018-01-16 06:14:34.020000000",
//     "4": "True",
//     "5": "20"
//   },
//   SurchargeMaster: {
//     "1": "429",
//     "2": "2015-01-01 0:00:00",
//     "3": "2035-01-01 0:00:00",
//     "4": "TRUE",
//     "5": "478",
//     "6": "1",
//     "7": "Cut - Trim"
//   },
//   TextUpgradeMaster: {
//     "1": "1",
//     "2": "50",
//     "3": "2006-08-15 12:45:13",
//     "4": "2035-01-01 0:00:00",
//     "5": "TRUE"
//   },
// };

var pricerFieldsIdx$1 = {
  ProcessMaster: {
    ProcessID: 1,
    ProcessAvailabilityStart: 2,
    ProcessAvailabilityEnd: 3,
    ProcessIsActive: 4,
    TextUpgradeOverride: 5,
    AddlPressRunNoDie: 6,
    AddlPressRunWithDie: 7
  },
  RateQuantity: {
    ProcessID: 1,
    RateID: 2,
    RateQuantityHigh: 3,
    RateQuantityLow: 4,
    RateQuantityAvailabilityStart: 5,
    RateQuantityAvailabilityEnd: 6,
    RateQuantityIsActive: 7,
    RateAmount: 8,
    RateQuantityID: 9
  },
  RateMaster: {
    RateBasedAPR: 1,
    RateID: 2,
    RateAvailabilityStart: 3,
    RateAvailabilityEnd: 4,
    APRCalculation: 5
  },
  DieTypeProcessXRef: {
    ProcessID: 1,
    DieTypeID: 2,
    DieTypePrice: 3,
    DieChargePerLine: 4
  },
  ItemPriceBase: {
    JDEShortItemNumber: 1,
    PriceBasePer25: 2,
    ItemPriceBaseAvailabilityStart: 3,
    ItemPriceBaseAvailabilityEnd: 4,
    ItemPriceBaseIsActive: 5
  },
  ItemPriceException: {
    OrderedItemNumber: 1,
    PriceExceptionPer25: 2,
    ItemPriceExceptionAvailabilityStart: 3,
    ItemPriceExceptionAvailabilityEnd: 4,
    ItemPriceExceptionIsActive: 5
  },
  TextUpgradeMaster: {
    TextUpGradeID: 1,
    TextUpgradePrice: 2,
    TextUpGradeAvailabilityStart: 3,
    TextUpGradeAvailabilityEnd: 4,
    TextUpGradeIsActive: 5
  },
  LinerPricingCategoryMaster: {
    LinerPricingCategoryShortDesc: 1,
    LinerPricingCategoryPrice: 2,
    LinerPricingCategoryAvailabilityStart: 3,
    LinerPricingCategoryAvailabilityEnd: 4,
    LinerPricingCategoryIsActive: 5
  },
  ItemXRef: {
    OrderedItemNumber: 1,
    ItemID: 2,
    ItemAvailabilityStart: 3,
    ItemAvailabilityEnd: 4,
    ItemIsActive: 5,
    JDEShortItemNumber: 6,
    PriceGroup: 7
  },
  PriceSublineQuantityXRef: {
    IsActive: 1,
    QuantityPrice: 2,
    QuantityValue: 3,
    AvailabilityEnd: 4,
    MinimumQuantity: 5,
    AvailabilityStart: 6,
    SublineQuantityId: 7,
    PriceSublineTypeId: 8
  },
  SuppliedMaterialDetail: {
    SuppliedMaterialID: 1,
    SuppliedMaterialAvailabilityStart: 2,
    SuppliedMaterialAvailabilityEnd: 3,
    SuppliedMaterialIsActive: 4,
    SuppliedMaterialTypeID: 5
  },
  SurchargeMaster: {
    SurchargeShortDesc: 1,
    SurchargeAvailabilityStart: 2,
    SurchargeAvailabilityEnd: 3,
    SurchargeIsActive: 4,
    SurchargeID: 5,
    SurchargeTypeID: 6,
    SurchargeDescription: 7
  },
  PricingSublineProcessHierarchyXRef: {
    ProcessId: 1,
    SublineTypeId: 2,
    AvailabilityStart: 3,
    AvailabilityEnd: 4,
    IsActive: 5,
    HierarchyOrder: 6
  },
  PriceSublineTypeMaster: {
    IsActive: 1,
    SublineTypeId: 2,
    AvailabilityEnd: 3,
    AvailabilityStart: 4,
    PriceSublineTypeId: 5,
    SublineTypeShortDesc: 6,
    CorrespondingPriceSurchargeTypeId: 7
  },
  OccasionUseXRef: {
    OccasionID: 1,
    UseID: 2,
    RateID: 3,
    TextUpgradeID: 4,
    DieTypeID: 5
  }
};
var pricerFiles = {
  DieTypeProcessXRef: [],
  ItemPriceBase: [],
  ItemPriceException: [],
  ItemXRef: [],
  LinerPricingCategoryMaster: [],
  OccasionUseXRef: [],
  PriceSublineFlatXRef: [],
  PriceSublineQuantityXRef: [],
  PriceSublineTypeMaster: [],
  PricingSublineProcessHierarchyXRef: [],
  ProcessMaster: [],
  RateMaster: [],
  RateQuantity: [],
  RibbonTyingStyleMaster: [],
  SuppliedMaterialDetail: [],
  SurchargeMaster: [],
  TextUpgradeMaster: []
};

export { combine, createPartStrucureFromSvgElementAllOptions, getCurrentSvgPartStructure, _getPartStructure as getPartStructure, getPriceDelta, priceProduct, pricerFieldsIdx$1 as pricerFieldsIdx, pricerFiles, pricingEngine };
